export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export enum AccessLevel {
  BrandWide = 'BrandWide',
  Private = 'Private',
  Restricted = 'Restricted',
  SiteWide = 'SiteWide'
}

export type AltTextPendingImage = {
  __typename?: 'AltTextPendingImage';
  currentAltText?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  revisionSchemaId: Scalars['Int']['output'];
};

export type AnnounceCampaignDto = {
  campaignId: Scalars['Int']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetEntityDto = {
  __typename?: 'AssetEntityDto';
  accessLevel?: Maybe<AccessLevel>;
  altText?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isAssociated: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  type: AssetType;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export enum AssetType {
  Archive = 'Archive',
  Document = 'Document',
  Folder = 'Folder',
  Html = 'Html',
  Image = 'Image',
  Video = 'Video'
}

export type AssetUploadResponseDto = {
  __typename?: 'AssetUploadResponseDto';
  accessLevel?: Maybe<AccessLevel>;
  altText?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isAssociated: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  signedURL: Scalars['String']['output'];
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  type: AssetType;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export enum AuditAction {
  Announce = 'Announce',
  CancelScheduledPublish = 'CancelScheduledPublish',
  Create = 'Create',
  Delete = 'Delete',
  Duplicate = 'Duplicate',
  DuplicatePage = 'DuplicatePage',
  End = 'End',
  Impersonate = 'Impersonate',
  Login = 'Login',
  OptIn = 'OptIn',
  OptOut = 'OptOut',
  Publish = 'Publish',
  ReadyEnd = 'ReadyEnd',
  ReadyStart = 'ReadyStart',
  Restore = 'Restore',
  Revalidate = 'Revalidate',
  SchedulePublish = 'SchedulePublish',
  Start = 'Start',
  SyncEnd = 'SyncEnd',
  SyncError = 'SyncError',
  SyncProgress = 'SyncProgress',
  SyncStart = 'SyncStart',
  Unpublish = 'Unpublish',
  Update = 'Update'
}

export type AuditLogEntityDto = {
  __typename?: 'AuditLogEntityDto';
  action?: Maybe<AuditAction>;
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  detailObj: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  impersonatingUser?: Maybe<AuditLogUserDto>;
  page?: Maybe<AuditLogPageDto>;
  resourceId?: Maybe<Scalars['Int']['output']>;
  resourceType?: Maybe<AuditResourceType>;
  user?: Maybe<AuditLogUserDto>;
};

export type AuditLogPageDto = {
  __typename?: 'AuditLogPageDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
};

export type AuditLogUserDto = {
  __typename?: 'AuditLogUserDto';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export enum AuditResourceType {
  Asset = 'Asset',
  Brand = 'Brand',
  Campaign = 'Campaign',
  Dashboard = 'Dashboard',
  Domain = 'Domain',
  FeatureFlag = 'FeatureFlag',
  Form = 'Form',
  FormField = 'FormField',
  FormIntegration = 'FormIntegration',
  FormIntegrationAction = 'FormIntegrationAction',
  GmbAccount = 'GmbAccount',
  GmbLocation = 'GmbLocation',
  GmbReview = 'GmbReview',
  GoogleAccount = 'GoogleAccount',
  GoogleAccountSubaccount = 'GoogleAccountSubaccount',
  InstagramMedia = 'InstagramMedia',
  Integration = 'Integration',
  MetaAccount = 'MetaAccount',
  Organisation = 'Organisation',
  Page = 'Page',
  Redirect = 'Redirect',
  Revision = 'Revision',
  RevisionSchema = 'RevisionSchema',
  Site = 'Site',
  TtSchema = 'TTSchema',
  TtSchemaField = 'TTSchemaField',
  TtSchemaWrapper = 'TTSchemaWrapper',
  Template = 'Template',
  User = 'User',
  UserApiKey = 'UserApiKey',
  UserGoogleAccount = 'UserGoogleAccount',
  UserMetaAccount = 'UserMetaAccount',
  UserResource = 'UserResource'
}

export type AuthResult = {
  __typename?: 'AuthResult';
  success: Scalars['Boolean']['output'];
  user?: Maybe<UserEntityDto>;
};

export enum BotProtectionType {
  None = 'none',
  ReCaptchaV2 = 'reCAPTCHA_v2',
  ReCaptchaV2Invisible = 'reCAPTCHA_v2_Invisible',
  ReCaptchaV3 = 'reCAPTCHA_v3'
}

export type BrandEntityDto = {
  __typename?: 'BrandEntityDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organisation: OrganisationEntityDto;
  sites: Array<SiteEntityDto>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: BreadcrumbType;
  urlPath: Scalars['String']['output'];
};

export enum BreadcrumbType {
  Brand = 'Brand',
  Page = 'Page',
  Site = 'Site'
}

export type BulkUpdateAltTextItem = {
  fileName: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  revisionSchemaId: Scalars['Int']['input'];
  updatedAltText: Scalars['String']['input'];
};

export type BulkUpdateAltTextResult = {
  __typename?: 'BulkUpdateAltTextResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type CampaignAnnouncementResult = {
  __typename?: 'CampaignAnnouncementResult';
  success: Scalars['Boolean']['output'];
};

export enum CampaignConsentType {
  Mandatory = 'Mandatory',
  OptIn = 'OptIn',
  OptOut = 'OptOut'
}

export type CampaignDeleteResult = {
  __typename?: 'CampaignDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type CampaignEntityDto = {
  __typename?: 'CampaignEntityDto';
  campaignPageMetadata?: Maybe<CampaignPageMetadataDto>;
  consentType: CampaignConsentType;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageIds: Array<Scalars['Int']['output']>;
  pageType?: Maybe<TtSchemaEntityDto>;
  placeholderTemplates: Array<CampaignPlaceholderTemplateDto>;
  site: SiteEntityDto;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: CampaignStatus;
  type: CampaignType;
};

export type CampaignForceEndResult = {
  __typename?: 'CampaignForceEndResult';
  success: Scalars['Boolean']['output'];
};

export type CampaignForceStartResult = {
  __typename?: 'CampaignForceStartResult';
  success: Scalars['Boolean']['output'];
};

export type CampaignPageEntityDto = {
  __typename?: 'CampaignPageEntityDto';
  editable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  optedIn: Scalars['Boolean']['output'];
  page: PageEntityDto;
  subpage?: Maybe<PageEntityDto>;
};

export type CampaignPageMetadataCreateDto = {
  allowCrawling: Scalars['Boolean']['input'];
  metaDescription: Scalars['String']['input'];
  metaTitle: Scalars['String']['input'];
  templateId: Scalars['Float']['input'];
  urlSegment: Scalars['String']['input'];
};

export type CampaignPageMetadataDto = {
  __typename?: 'CampaignPageMetadataDto';
  allowCrawling: Scalars['Boolean']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  template: TemplateEntityDto;
  urlSegment: Scalars['String']['output'];
};

export type CampaignPageOptInStatusUpdateResult = {
  __typename?: 'CampaignPageOptInStatusUpdateResult';
  success: Scalars['Boolean']['output'];
};

export type CampaignPageUsageResult = {
  __typename?: 'CampaignPageUsageResult';
  usages?: Maybe<Array<CampaignEntityDto>>;
};

export type CampaignPagesOptInStatusAllUpdateDto = {
  campaignId: Scalars['Int']['input'];
  optIn: Scalars['Boolean']['input'];
};

export type CampaignPagesOptInStatusUpdateDto = {
  campaignId: Scalars['Int']['input'];
  optIn: Scalars['Boolean']['input'];
  pageIds: Array<Scalars['Int']['input']>;
};

export type CampaignPlaceholderDto = {
  __typename?: 'CampaignPlaceholderDto';
  campaign: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  schemaBlockId: Scalars['Int']['output'];
};

export type CampaignPlaceholderTemplateDto = {
  __typename?: 'CampaignPlaceholderTemplateDto';
  schemaBlockId: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
};

export type CampaignPlaceholderTemplateInputDto = {
  schemaBlockId: Scalars['Int']['input'];
  templateId: Scalars['Int']['input'];
};

export enum CampaignStatus {
  Announced = 'Announced',
  Draft = 'Draft',
  Ended = 'Ended',
  ReadyToEnd = 'ReadyToEnd',
  ReadyToRun = 'ReadyToRun',
  Running = 'Running'
}

export type CampaignTemplateUsageDto = {
  __typename?: 'CampaignTemplateUsageDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum CampaignType {
  Block = 'Block',
  Page = 'Page'
}

export type ClonePagesInput = {
  preserveTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  schemaMappings: Array<SchemaMappingInput>;
  sourcePageIds: Array<Scalars['Int']['input']>;
  targetParentPageId?: InputMaybe<Scalars['Int']['input']>;
  targetSiteId: Scalars['Int']['input'];
  templateMappings?: InputMaybe<Array<TemplateMappingInput>>;
};

export type CloneSiteInputDto = {
  /** Name for the new cloned site */
  newSiteName: Scalars['String']['input'];
  /** Optional primary domain ID for the new site */
  primaryDomainId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the site to clone */
  sourceSiteId: Scalars['Int']['input'];
};

export type CloneSiteResultDto = {
  __typename?: 'CloneSiteResultDto';
  /** Number of forms cloned */
  formsCloned: Scalars['Int']['output'];
  /** Number of pages cloned */
  pagesCloned: Scalars['Int']['output'];
  /** ID of the newly created site */
  targetSiteId: Scalars['Int']['output'];
  /** Name of the newly created site */
  targetSiteName: Scalars['String']['output'];
  /** Number of templates cloned */
  templatesCloned: Scalars['Int']['output'];
};

export type CloneTtSchemaWrapperInput = {
  name: Scalars['String']['input'];
  wrapperId: Scalars['Int']['input'];
};

export type CloneTemplateInput = {
  campaign?: InputMaybe<Scalars['Boolean']['input']>;
  existingTemplateId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TemplateType>;
};

export type CreateAssetInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  isAssociated: Scalars['Boolean']['input'];
  sizeInBytes?: InputMaybe<Scalars['Float']['input']>;
  type: AssetType;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateBrandDto = {
  name: Scalars['String']['input'];
  organisationId: Scalars['Int']['input'];
};

export type CreateCampaignDto = {
  consentType: CampaignConsentType;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageIds: Array<Scalars['Int']['input']>;
  pageMetadata?: InputMaybe<CampaignPageMetadataCreateDto>;
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  placeholderTemplates?: InputMaybe<Array<CampaignPlaceholderTemplateInputDto>>;
  siteId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  type: CampaignType;
};

export type CreateDashboardDto = {
  name: Scalars['String']['input'];
  organisationId: Scalars['Float']['input'];
};

export type CreateDomainDto = {
  domainName: Scalars['String']['input'];
  organisationId: Scalars['Int']['input'];
  ssl: Scalars['Boolean']['input'];
};

export type CreateFormFieldInputDto = {
  autocomplete?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<FormFieldConfigInput>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  helpText?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  placeholder: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type: FormFieldType;
};

export type CreateFormInputDto = {
  botProtectionIntegrationId?: InputMaybe<Scalars['Int']['input']>;
  enableRecaptcha?: Scalars['Boolean']['input'];
  formIdentifier?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  retentionPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  submitButtonLabel: Scalars['String']['input'];
  thankYouMessage: Scalars['String']['input'];
};

export type CreateFormIntegrationActionDto = {
  dependOnId?: InputMaybe<Scalars['Int']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledUntil?: InputMaybe<Scalars['DateTime']['input']>;
  formIntegrationId: Scalars['Int']['input'];
  integrationId: Scalars['Int']['input'];
  specification: Scalars['JSONObject']['input'];
};

export type CreateFormIntegrationActionLogDto = {
  formIntegrationActionId: Scalars['Int']['input'];
  isSuccess: Scalars['Boolean']['input'];
  requestData?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
  submissionId: Scalars['Int']['input'];
};

export type CreateFormIntegrationInputDto = {
  formId: Scalars['Int']['input'];
  pages?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateFormSubmissionInputDto = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  pageId?: InputMaybe<Scalars['Int']['input']>;
  revisionSchemaId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSONObject']['input'];
};

export type CreateIntegrationInputDto = {
  name: Scalars['String']['input'];
  organisationId: Scalars['Int']['input'];
  specification: Scalars['JSONObject']['input'];
  type: IntegrationType;
};

export type CreateOrganisationDto = {
  name: Scalars['String']['input'];
};

export type CreatePageDto = {
  allowCrawling?: InputMaybe<Scalars['Boolean']['input']>;
  customScriptBody?: InputMaybe<Scalars['String']['input']>;
  customScriptHead?: InputMaybe<Scalars['String']['input']>;
  draftRevisionId?: InputMaybe<Scalars['Int']['input']>;
  excludeFromSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Array<CustomPagePropertiesInput>>;
  publishedRevisionId?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  ttschemaId?: InputMaybe<Scalars['Int']['input']>;
  urlSegment: Scalars['String']['input'];
};

export type CreatePageRevisionInput = {
  currentDraftRevisionId?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  publish: Scalars['Boolean']['input'];
  references: Scalars['JSON']['input'];
  revisionSchemas: Array<PageRevisionSchemaInput>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  schemaDefinition?: InputMaybe<RevisionSchemaSchemaDefinitionDto>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: PageRevisionType;
};

export type CreatePageRevisionSchemaInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  properties: Array<PageRevisionSchemaPropertiesInput>;
  revisionId: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
  ttschemaId: Scalars['Int']['input'];
};

export type CreateRedirectEntityDto = {
  fromPath: Scalars['String']['input'];
  siteId: Scalars['Int']['input'];
  status: RedirectStatus;
  toPageId?: InputMaybe<Scalars['Int']['input']>;
  toType: RedirectToType;
  toUrl?: InputMaybe<Scalars['String']['input']>;
  type: RedirectType;
};

export type CreateSiteDto = {
  brandId: Scalars['Int']['input'];
  customScriptBody?: InputMaybe<Scalars['String']['input']>;
  customScriptHead?: InputMaybe<Scalars['String']['input']>;
  error404TemplateId?: InputMaybe<Scalars['Int']['input']>;
  error500TemplateId?: InputMaybe<Scalars['Int']['input']>;
  footerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  googleAccountId?: InputMaybe<Scalars['Float']['input']>;
  googleAnalyticsAccountId?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsPropertyId?: InputMaybe<Scalars['String']['input']>;
  headerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  homepageId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  ttSchemaWrapperId: Scalars['Int']['input'];
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTtSchemaFieldDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  hasMultipleValues?: Scalars['Boolean']['input'];
  helpText?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  readOnly?: Scalars['Boolean']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Int']['input'];
  ttschemaId: Scalars['Int']['input'];
  type: TtSchemaFieldType;
  typeDefinition?: InputMaybe<Scalars['JSON']['input']>;
  typeTTSchemaId?: InputMaybe<Scalars['Int']['input']>;
  visibility: TtSchemaFieldVisibility;
};

export type CreateTtSchemaInput = {
  name: Scalars['String']['input'];
  titlePlural: Scalars['String']['input'];
  titleSingular: Scalars['String']['input'];
  ttSchemaWrapperId: Scalars['Int']['input'];
  type: TtSchemaType;
  visibility: TtSchemaVisibility;
};

export type CreateTemplateInput = {
  campaign: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  type: TemplateType;
};

export type CreateUserApiTokenResult = {
  __typename?: 'CreateUserApiTokenResult';
  apiKey: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomPagePropertiesInput = {
  fieldId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type DashboardEntityDto = {
  __typename?: 'DashboardEntityDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  panels: Array<DashboardPanelConfig>;
};

export type DashboardPanelConfig = {
  __typename?: 'DashboardPanelConfig';
  id: Scalars['String']['output'];
  type: DashboardPanelType;
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type DashboardPanelConfigInput = {
  id: Scalars['String']['input'];
  type: DashboardPanelType;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export enum DashboardPanelType {
  AgeDistribution = 'AgeDistribution',
  AverageSession = 'AverageSession',
  ConversionRate = 'ConversionRate',
  LeadSources = 'LeadSources',
  LeadsByTime = 'LeadsByTime',
  LinkClicks = 'LinkClicks',
  LocationsOverTime = 'LocationsOverTime',
  NumberOfLeads = 'NumberOfLeads',
  TopClicked = 'TopClicked',
  TopLeadPages = 'TopLeadPages',
  TotalLeads = 'TotalLeads',
  TotalSessions = 'TotalSessions'
}

export type DeleteUserApiTokenResult = {
  __typename?: 'DeleteUserApiTokenResult';
  success: Scalars['Boolean']['output'];
};

export type DeviceScreenshotDto = {
  __typename?: 'DeviceScreenshotDto';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Scalars['String']['output']>;
};

export type DeviceScreenshotInput = {
  desktop?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  tablet?: InputMaybe<Scalars['String']['input']>;
};

export type DisconnectUserGoogleAccountResult = {
  __typename?: 'DisconnectUserGoogleAccountResult';
  success: Scalars['Boolean']['output'];
};

export type DisconnectUserMetaAccountResult = {
  __typename?: 'DisconnectUserMetaAccountResult';
  success: Scalars['Boolean']['output'];
};

export type DomainEntityDto = {
  __typename?: 'DomainEntityDto';
  alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  robots: Scalars['String']['output'];
  siteDomains: Array<SiteDomainDto>;
  sitemap: Scalars['String']['output'];
  ssl: Scalars['Boolean']['output'];
  verification: Scalars['Boolean']['output'];
};

export enum ErrorTemplateType {
  Error404 = 'Error404',
  Error500 = 'Error500'
}

export type EvaluatedFeatureFlagDto = {
  __typename?: 'EvaluatedFeatureFlagDto';
  isEnabled: Scalars['Boolean']['output'];
  name: FeatureFlagName;
  /** Feature-specific configuration options */
  options: Scalars['JSON']['output'];
};

export type FiasesRecipient = {
  __typename?: 'FIASESRecipient';
  id: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type FiaSendgridRecipient = {
  __typename?: 'FIASendgridRecipient';
  id: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type FeatureFlagConfigurationDto = {
  __typename?: 'FeatureFlagConfigurationDto';
  context: Scalars['JSON']['output'];
  enableTime?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  name: FeatureFlagName;
  /** Feature-specific configuration options */
  options: Scalars['JSON']['output'];
};

export type FeatureFlagEntityDto = {
  __typename?: 'FeatureFlagEntityDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: FeatureFlagName;
  /** Configuration options for the feature flag */
  options: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureFlagEvaluationContextInputDto = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

/** Enum for feature flag names */
export enum FeatureFlagName {
  CampaignMonitoring = 'CampaignMonitoring',
  FormSubmissionEnqueue = 'FormSubmissionEnqueue',
  InputValidation = 'InputValidation',
  KeycloakAuth = 'KeycloakAuth',
  MetaIntegration = 'MetaIntegration',
  Notifications = 'Notifications',
  PageResolution = 'PageResolution',
  Reporting = 'Reporting'
}

export type ForceResyncGoogleAccountResult = {
  __typename?: 'ForceResyncGoogleAccountResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FormEntityDto = {
  __typename?: 'FormEntityDto';
  botProtection: BotProtectionType;
  botProtectionIntegration?: Maybe<IntegrationDto>;
  enableRecaptcha: Scalars['Boolean']['output'];
  fields: Array<FormFieldEntityDto>;
  formIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  integrations: Array<FormIntegrationEntityDto>;
  lastSubmission?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  recaptchaSiteToken?: Maybe<Scalars['String']['output']>;
  retentionPeriodDays?: Maybe<Scalars['Int']['output']>;
  site: SiteEntityDto;
  submitButtonLabel: Scalars['String']['output'];
  thankYouMessage: Scalars['String']['output'];
};

export type FormFieldConfig = {
  __typename?: 'FormFieldConfig';
  customCss?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  inputType?: Maybe<FormFieldInputType>;
  options?: Maybe<Array<KeyValue>>;
  presentation?: Maybe<PresentationType>;
  validation?: Maybe<FormFieldValidationConfig>;
};

export type FormFieldConfigInput = {
  customCss?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<FormFieldInputType>;
  options?: InputMaybe<Array<KeyValueInput>>;
  presentation?: InputMaybe<PresentationType>;
  validation?: InputMaybe<FormFieldValidationConfigInput>;
};

export enum FormFieldConstraintType {
  Required = 'REQUIRED',
  StringEmail = 'STRING_EMAIL',
  StringLength = 'STRING_LENGTH',
  StringMatch = 'STRING_MATCH',
  StringMaximumLength = 'STRING_MAXIMUM_LENGTH',
  StringMinimumLength = 'STRING_MINIMUM_LENGTH'
}

export type FormFieldEntityDto = {
  __typename?: 'FormFieldEntityDto';
  autocomplete?: Maybe<Scalars['String']['output']>;
  config?: Maybe<FormFieldConfig>;
  fieldIdentifier?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type: FormFieldType;
};

export enum FormFieldInputType {
  Date = 'Date',
  Email = 'Email',
  Number = 'Number',
  Phone = 'Phone',
  Text = 'Text'
}

export enum FormFieldType {
  Consent = 'Consent',
  Hidden = 'Hidden',
  Info = 'Info',
  Select = 'Select',
  Text = 'Text',
  Textarea = 'Textarea'
}

export type FormFieldValidationConfig = {
  __typename?: 'FormFieldValidationConfig';
  constraints: Array<FormFieldValidationConstraint>;
};

export type FormFieldValidationConfigInput = {
  constraints: Array<FormFieldValidationConstraintInput>;
};

export type FormFieldValidationConstraint = {
  __typename?: 'FormFieldValidationConstraint';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  props: Scalars['JSON']['output'];
  type: FormFieldConstraintType;
};

export type FormFieldValidationConstraintInput = {
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
  props: Scalars['JSON']['input'];
  type: FormFieldConstraintType;
};

export type FormIntegrationActionEntityDto = {
  __typename?: 'FormIntegrationActionEntityDto';
  disabled: Scalars['Boolean']['output'];
  disabledUntil?: Maybe<Scalars['DateTime']['output']>;
  formIntegration?: Maybe<FormIntegrationEntityDto>;
  id: Scalars['Int']['output'];
  integration?: Maybe<IntegrationDto>;
  specification: Scalars['JSONObject']['output'];
};

export type FormIntegrationActionLogEntity = {
  __typename?: 'FormIntegrationActionLogEntity';
  formIntegrationAction?: Maybe<FormIntegrationActionEntityDto>;
  id: Scalars['Int']['output'];
  isSuccess: Scalars['Boolean']['output'];
  requestData?: Maybe<Scalars['String']['output']>;
  response: Scalars['String']['output'];
  submission?: Maybe<FormSubmissionEntityDto>;
};

export type FormIntegrationEntityDto = {
  __typename?: 'FormIntegrationEntityDto';
  actions?: Maybe<Array<FormIntegrationActionEntityDto>>;
  id: Scalars['Int']['output'];
  /** Pages associated with this form integration. If empty, integration applies to all pages. */
  pages: Array<PageEntityDto>;
};

export type FormSubmissionActionDto = {
  __typename?: 'FormSubmissionActionDto';
  hasActionLog: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pendingAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FormSubmissionEnqueueFlagOptionsDto = {
  __typename?: 'FormSubmissionEnqueueFlagOptionsDto';
  enabled: Scalars['Boolean']['output'];
  useNewLogic: Scalars['Boolean']['output'];
};

export type FormSubmissionEntityDto = {
  __typename?: 'FormSubmissionEntityDto';
  actionLogs: Array<FormSubmissionIntegrationActionLogEntityDto>;
  actions: Array<FormSubmissionActionDto>;
  createdAt: Scalars['String']['output'];
  form?: Maybe<FormEntityDto>;
  id: Scalars['Int']['output'];
  page?: Maybe<PageEntityDto>;
  recaptchaCheckStatus: RecaptchaCheckStatus;
  recaptchaScore?: Maybe<Scalars['Float']['output']>;
  redirectURL?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSONObject']['output'];
};

export type FormSubmissionIntegrationActionEntityDto = {
  __typename?: 'FormSubmissionIntegrationActionEntityDto';
  id: Scalars['Int']['output'];
  specification: Scalars['JSONObject']['output'];
};

export type FormSubmissionIntegrationActionLogEntityDto = {
  __typename?: 'FormSubmissionIntegrationActionLogEntityDto';
  action: FormSubmissionIntegrationActionEntityDto;
  createdAt: Scalars['DateTime']['output'];
  integration?: Maybe<FormSubmissionIntegrationEntityDto>;
  isSuccess: Scalars['Boolean']['output'];
  requestData?: Maybe<Scalars['String']['output']>;
  response: Scalars['String']['output'];
};

export type FormSubmissionIntegrationEntityDto = {
  __typename?: 'FormSubmissionIntegrationEntityDto';
  name: Scalars['String']['output'];
};

export type FranConnectSyncProcessDto = {
  events: Array<FranconnectChangeEvent>;
  webhookConfig: FranconnectSyncWebhookProps;
};

export type FranConnectSyncProcessResultDto = {
  __typename?: 'FranConnectSyncProcessResultDto';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FranconnectChangeEvent = {
  referenceId: Scalars['String']['input'];
  subModule: Scalars['String']['input'];
};

export type FranconnectSyncWebhookProps = {
  apiOrigin?: Scalars['String']['input'];
  key?: Scalars['String']['input'];
  tenantId?: Scalars['String']['input'];
};

export type GenerateSchemaBlockThumbnailResult = {
  __typename?: 'GenerateSchemaBlockThumbnailResult';
  success: Scalars['Boolean']['output'];
};

export type GenerateSiteThumbnailResult = {
  __typename?: 'GenerateSiteThumbnailResult';
  success: Scalars['Boolean']['output'];
};

export type GenerateTemplateThumbnailResult = {
  __typename?: 'GenerateTemplateThumbnailResult';
  success: Scalars['Int']['output'];
};

export type GeneratedAltText = {
  __typename?: 'GeneratedAltText';
  results: Array<GeneratedAltTextItem>;
};

export type GeneratedAltTextItem = {
  __typename?: 'GeneratedAltTextItem';
  altText: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export enum GlofoxForm {
  Join = 'Join',
  Tour = 'Tour',
  Trial = 'Trial'
}

export type GlofoxFormLeadsPaginationParams = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  form: GlofoxForm;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Restrict paginated entities to those the user has a particular role on */
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GlofoxFormSubmission = {
  __typename?: 'GlofoxFormSubmission';
  agreementsStatus: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  glofoxBranchId: Scalars['String']['output'];
  glofoxUserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  page?: Maybe<GlofoxFormSubmissionPageDto>;
  pageId: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type GlofoxFormSubmissionPageDto = {
  __typename?: 'GlofoxFormSubmissionPageDto';
  name: Scalars['String']['output'];
  urlPath: Scalars['String']['output'];
};

export type GmbLocationEntityDto = {
  __typename?: 'GmbLocationEntityDto';
  addressLines?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  gmbAccountName?: Maybe<Scalars['String']['output']>;
  gmbName: Scalars['String']['output'];
  googleAccounts: Array<GmbLocationGoogleAccountDto>;
  id: Scalars['Int']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  sublocality?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GmbLocationGoogleAccountDto = {
  __typename?: 'GmbLocationGoogleAccountDto';
  accountId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
};

export type GmbLocationMappingEntityDto = {
  __typename?: 'GmbLocationMappingEntityDto';
  field: TtSchemaFieldEntityDto;
  fieldName: Scalars['String']['output'];
  gmbLocation: GmbLocationEntityDto;
  googleAccount: GoogleAccountEntityDto;
  id: Scalars['Int']['output'];
  page: PageEntityDto;
  site: SiteEntityDto;
};

export type GmbLocationPaginationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleAccountConnectionStatus = {
  __typename?: 'GoogleAccountConnectionStatus';
  connected: Scalars['Boolean']['output'];
  error: Scalars['String']['output'];
};

export type GoogleAccountEntityDto = {
  __typename?: 'GoogleAccountEntityDto';
  accountId: Scalars['String']['output'];
  blocksMapped?: Maybe<Scalars['Int']['output']>;
  connectionStatus: GoogleAccountConnectionStatus;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  refreshTokenStatus: RefreshTokenStatus;
};

export type GoogleAnalyticsAccountDto = {
  __typename?: 'GoogleAnalyticsAccountDto';
  accountId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type GoogleAnalyticsPropertyDto = {
  __typename?: 'GoogleAnalyticsPropertyDto';
  displayName: Scalars['String']['output'];
  propertyId: Scalars['String']['output'];
};

export type GrantUserResourceDto = {
  email: Scalars['String']['input'];
  resourceId: Scalars['Int']['input'];
  resourceIdentifier: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

export type ImpersonateResult = {
  __typename?: 'ImpersonateResult';
  success: Scalars['Boolean']['output'];
};

export type ImportPagesFromJsonInput = {
  overrideTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  pageFieldMappings: Array<JsonPageFieldMappingInput>;
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  pages: Array<Scalars['JSON']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportPagesFromJsonResult = {
  __typename?: 'ImportPagesFromJsonResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  pagesCreated: Array<PageEntityDto>;
  success: Scalars['Boolean']['output'];
};

export type ImportRedirectItem = {
  destination: Scalars['String']['input'];
  source: Scalars['String']['input'];
  status?: InputMaybe<RedirectStatus>;
  type?: InputMaybe<RedirectType>;
};

export enum ImportRedirectOutcome {
  Invalid = 'Invalid',
  Page = 'Page',
  Url = 'Url'
}

export type ImportRedirectResolution = {
  __typename?: 'ImportRedirectResolution';
  destination: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  outcome: ImportRedirectOutcome;
  pageId?: Maybe<Scalars['Int']['output']>;
  pageUrlPath?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  status: RedirectStatus;
  toUrl?: Maybe<Scalars['String']['output']>;
  type: RedirectType;
};

export type ImportRedirectsPreview = {
  __typename?: 'ImportRedirectsPreview';
  invalidCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  rows: Array<ImportRedirectResolution>;
  urlCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
};

export type ImportRedirectsResult = {
  __typename?: 'ImportRedirectsResult';
  createdCount: Scalars['Int']['output'];
  rows: Array<ImportRedirectResolution>;
  skippedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type InputValidationFlagOptionsDto = {
  __typename?: 'InputValidationFlagOptionsDto';
  enabled: Scalars['Boolean']['output'];
};

export type IntegrationConnectionStatus = {
  __typename?: 'IntegrationConnectionStatus';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IntegrationDeleteArgs = {
  id: Scalars['Int']['input'];
};

export type IntegrationDto = {
  __typename?: 'IntegrationDto';
  connectionStatus?: Maybe<IntegrationConnectionStatus>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organisationId?: Maybe<Scalars['Int']['output']>;
  specification?: Maybe<Scalars['JSONObject']['output']>;
  type: IntegrationType;
};

export enum IntegrationType {
  Clubwise = 'Clubwise',
  GloFox = 'GloFox',
  GymSales = 'GymSales',
  KeepMe = 'KeepMe',
  RecaptchaV3 = 'RecaptchaV3',
  Sendgrid = 'Sendgrid',
  ZapierWebhook = 'ZapierWebhook'
}

export type JsonPageFieldMappingInput = {
  fieldId: Scalars['String']['input'];
  fieldType?: InputMaybe<TtSchemaFieldType>;
  sourceItemProperty?: InputMaybe<Scalars['String']['input']>;
  sourceProperty: Scalars['String']['input'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValueInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LeadDataPoint = {
  __typename?: 'LeadDataPoint';
  date: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
};

export type MetaAccountConnectionStatus = {
  __typename?: 'MetaAccountConnectionStatus';
  connected: Scalars['Boolean']['output'];
  error: Scalars['String']['output'];
};

export type MetaAccountEntityDto = {
  __typename?: 'MetaAccountEntityDto';
  accountId: Scalars['String']['output'];
  connectionStatus: MetaAccountConnectionStatus;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  linkMethod: MetaLinkMethod;
};

export enum MetaLinkMethod {
  Facebook = 'Facebook',
  Instagram = 'Instagram'
}

export type Mutation = {
  __typename?: 'Mutation';
  announceCampaign: CampaignAnnouncementResult;
  bulkUpdateAltText: BulkUpdateAltTextResult;
  cancelScheduledPublish: PageEntityDto;
  cancelScheduledTemplatePublish: TemplateEntityDto;
  clonePages: PageCloneResult;
  cloneSite: CloneSiteResultDto;
  cloneTTSchemaWrapper: TtSchemaWrapperEntityDto;
  cloneTemplate: TemplateEntityDto;
  copyFormIntegrationActionsToAnotherGroup: FormIntegrationEntityDto;
  createBrand: BrandEntityDto;
  createCampaign: CampaignEntityDto;
  createDashboard: DashboardEntityDto;
  createDomain: DomainEntityDto;
  createForm: FormEntityDto;
  createFormField: FormFieldEntityDto;
  createFormIntegration: FormIntegrationEntityDto;
  createFormIntegrationAction: FormIntegrationActionEntityDto;
  createFormIntegrationActionLog: FormIntegrationActionLogEntity;
  createIntegration: IntegrationDto;
  createOrganisation: OrganisationEntityDto;
  createPage: PageEntityDto;
  createPageRevision: PageRevisionEntityDto;
  createPageRevisionSchema: PageRevisionSchemaEntityDto;
  createPasswordReset: ResetPasswordResult;
  createRedirect: RedirectEntityDto;
  createSchemaBlock: SchemaBlockEntityDto;
  createSite: SiteEntityDto;
  createSubmission: FormSubmissionEntityDto;
  createTTSchema: TtSchemaEntityDto;
  createTTSchemaField: TtSchemaFieldEntityDto;
  createTTSchemaWrapper: TtSchemaWrapperEntityDto;
  createTemplate: TemplateEntityDto;
  createUserApiToken: CreateUserApiTokenResult;
  deleteBrand: BrandEntityDto;
  deleteCampaign: CampaignDeleteResult;
  deleteDomain: DomainEntityDto;
  deleteForm: FormEntityDto;
  deleteFormField: FormFieldEntityDto;
  deleteFormIntegration: FormIntegrationEntityDto;
  deleteFormIntegrationAction: FormIntegrationActionEntityDto;
  deleteIntegration: IntegrationDto;
  deleteOrganisation: OrganisationEntityDto;
  deletePage: PageEntityDto;
  deleteRedirect: RedirectEntityDto;
  deleteSite: SiteEntityDto;
  deleteTTSchema: TtSchemaDeleteResult;
  deleteTTSchemaField: TtSchemaFieldDeleteResult;
  deleteTTSchemaWrapper: TtSchemaWrapperDeleteResult;
  deleteTemplate: TemplateEntityDto;
  deleteTemplateAndPages: TemplateEntityDto;
  deleteUserApiToken: DeleteUserApiTokenResult;
  deleteUserResource: UserResourceEntityDto;
  detachPagesAndDeleteTemplate: TemplateEntityDto;
  discardPageDraft?: Maybe<PageEntityDto>;
  discardTemplateDraft?: Maybe<TemplateEntityDto>;
  disconnectUserGoogleAccount: DisconnectUserGoogleAccountResult;
  disconnectUserMetaAccount: DisconnectUserMetaAccountResult;
  duplicateForm: FormEntityDto;
  duplicatePage: PageEntityDto;
  exitImpersonate: ImpersonateResult;
  forceEndCampaign: CampaignForceEndResult;
  forceStartCampaign: CampaignForceStartResult;
  generateSchemaBlockThumbnail: GenerateSchemaBlockThumbnailResult;
  generateSiteThumbnail: GenerateSiteThumbnailResult;
  generateTemplateThumbnail: GenerateTemplateThumbnailResult;
  grantUserResourceByEmail: UserResourceEntityDto;
  impersonate: ImpersonateResult;
  importPagesFromJson: ImportPagesFromJsonResult;
  importRedirects: ImportRedirectsResult;
  logout: AuthResult;
  presignedUrl: AssetUploadResponseDto;
  previewImportRedirects: ImportRedirectsPreview;
  processFranConnectChanges: FranConnectSyncProcessResultDto;
  publishPage: PublishPageResult;
  removePageRevision: PageRevisionEntityDto;
  removePageRevisionSchema: PageRevisionSchemaEntityDto;
  resetPassword: ResetPasswordResult;
  resetPasswordWithToken: ResetPasswordResult;
  restoreDeletedTTSchema: TtSchemaEntityDto;
  restoreDeletedTTSchemaField: TtSchemaFieldEntityDto;
  retriggerFormSubmissionActions: RetriggerFormSubmissionActionsResponseDto;
  revokeAllUserResourcesForOrganisation: RevokeAllUserResourcesOnOrganisationResult;
  /** Set the dashboard banner message (super admin only) */
  setBannerMessage: Scalars['Boolean']['output'];
  syncAllGmbData: SyncResult;
  syncAllGoogleAccounts: SyncAllGoogleAccountsResult;
  syncGmbAccountData: SyncResult;
  syncGmbLocationData: SyncResult;
  syncGoogleAccount: ForceResyncGoogleAccountResult;
  unpublishPage: UnpublishPageResult;
  updateAllCampaignPagesOptInStatuses: CampaignPageOptInStatusUpdateResult;
  updateBrand: BrandEntityDto;
  updateCampaign: CampaignEntityDto;
  updateCampaignPageOptInStatuses: CampaignPageOptInStatusUpdateResult;
  updateDashboard: DashboardEntityDto;
  updateFeatureFlag: FeatureFlagEntityDto;
  updateFeatureFlagConfiguration: FeatureFlagConfigurationDto;
  updateForm: FormEntityDto;
  updateFormField: FormFieldEntityDto;
  updateFormIntegrationAction: FormIntegrationActionEntityDto;
  updateFormIntegrationPages: FormIntegrationEntityDto;
  updateIntegration: IntegrationDto;
  updateOrganisation: OrganisationEntityDto;
  updatePage: PageEntityDto;
  updatePageSEOSettings: PageEntityDto;
  updatePreferredLocale: UserEntityDto;
  updateRedirect: RedirectEntityDto;
  updateSite: SiteEntityDto;
  updateSiteFormNotificationEmails: Array<SiteFormNotificationEmailDto>;
  updateSortOrder: Array<FormFieldEntityDto>;
  updateTTSchema: TtSchemaEntityDto;
  updateTTSchemaField: TtSchemaFieldEntityDto;
  updateTTSchemaFieldOrder: TtSchemaFieldSortOrderUpdateResult;
  updateTTSchemaWrapper: TtSchemaWrapperEntityDto;
  updateTemplate: TemplateEntityDto;
  updateUserWithToken: UserEntityDto;
};


export type MutationAnnounceCampaignArgs = {
  announceCampaignDto: AnnounceCampaignDto;
};


export type MutationBulkUpdateAltTextArgs = {
  draftCustomFieldsId?: InputMaybe<Scalars['Int']['input']>;
  draftRevisionId?: InputMaybe<Scalars['Int']['input']>;
  items: Array<BulkUpdateAltTextItem>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCancelScheduledPublishArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCancelScheduledTemplatePublishArgs = {
  id: Scalars['Int']['input'];
};


export type MutationClonePagesArgs = {
  clonePagesInput: ClonePagesInput;
};


export type MutationCloneSiteArgs = {
  input: CloneSiteInputDto;
};


export type MutationCloneTtSchemaWrapperArgs = {
  cloneTTSchemaWrapperInput: CloneTtSchemaWrapperInput;
};


export type MutationCloneTemplateArgs = {
  cloneTemplateInput: CloneTemplateInput;
};


export type MutationCopyFormIntegrationActionsToAnotherGroupArgs = {
  formIntegrationId: Scalars['Int']['input'];
  targetFormIntegrationId: Scalars['Int']['input'];
};


export type MutationCreateBrandArgs = {
  brand: CreateBrandDto;
};


export type MutationCreateCampaignArgs = {
  createCampaignDto: CreateCampaignDto;
};


export type MutationCreateDashboardArgs = {
  dashboard: CreateDashboardDto;
};


export type MutationCreateDomainArgs = {
  domain: CreateDomainDto;
};


export type MutationCreateFormArgs = {
  form: CreateFormInputDto;
};


export type MutationCreateFormFieldArgs = {
  formField: CreateFormFieldInputDto;
};


export type MutationCreateFormIntegrationArgs = {
  formIntegration: CreateFormIntegrationInputDto;
};


export type MutationCreateFormIntegrationActionArgs = {
  formIntegrationAction: CreateFormIntegrationActionDto;
};


export type MutationCreateFormIntegrationActionLogArgs = {
  formIntegrationActionLog: CreateFormIntegrationActionLogDto;
};


export type MutationCreateIntegrationArgs = {
  integration: CreateIntegrationInputDto;
};


export type MutationCreateOrganisationArgs = {
  organisation: CreateOrganisationDto;
};


export type MutationCreatePageArgs = {
  page: CreatePageDto;
};


export type MutationCreatePageRevisionArgs = {
  createPageRevision: CreatePageRevisionInput;
};


export type MutationCreatePageRevisionSchemaArgs = {
  createPageRevisionSchema: CreatePageRevisionSchemaInput;
};


export type MutationCreatePasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationCreateRedirectArgs = {
  redirect: CreateRedirectEntityDto;
};


export type MutationCreateSiteArgs = {
  createSiteDto: CreateSiteDto;
};


export type MutationCreateSubmissionArgs = {
  submission: CreateFormSubmissionInputDto;
};


export type MutationCreateTtSchemaArgs = {
  createTTSchemaInput: CreateTtSchemaInput;
};


export type MutationCreateTtSchemaFieldArgs = {
  createTTSchemaFieldDto: CreateTtSchemaFieldDto;
};


export type MutationCreateTtSchemaWrapperArgs = {
  createTTSchemaWrapperInput: TtSchemaWrapperInput;
};


export type MutationCreateTemplateArgs = {
  createTemplateInput: CreateTemplateInput;
};


export type MutationCreateUserApiTokenArgs = {
  expirySecs?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteBrandArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDomainArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFormFieldArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFormIntegrationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFormIntegrationActionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteIntegrationArgs = {
  deleteIntegration: IntegrationDeleteArgs;
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRedirectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSiteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTtSchemaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTtSchemaFieldArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTtSchemaWrapperArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTemplateAndPagesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserApiTokenArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserResourceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDetachPagesAndDeleteTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDiscardPageDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDiscardTemplateDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDisconnectUserGoogleAccountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDisconnectUserMetaAccountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDuplicateFormArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDuplicatePageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationForceEndCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};


export type MutationForceStartCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};


export type MutationGenerateSchemaBlockThumbnailArgs = {
  blockId: Scalars['Int']['input'];
};


export type MutationGenerateSiteThumbnailArgs = {
  siteId: Scalars['Int']['input'];
};


export type MutationGenerateTemplateThumbnailArgs = {
  templateId: Scalars['Int']['input'];
};


export type MutationGrantUserResourceByEmailArgs = {
  userResource: GrantUserResourceDto;
};


export type MutationImpersonateArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationImportPagesFromJsonArgs = {
  importInput: ImportPagesFromJsonInput;
};


export type MutationImportRedirectsArgs = {
  items: Array<ImportRedirectItem>;
  siteId: Scalars['Int']['input'];
};


export type MutationPresignedUrlArgs = {
  asset: CreateAssetInput;
};


export type MutationPreviewImportRedirectsArgs = {
  items: Array<ImportRedirectItem>;
  siteId: Scalars['Int']['input'];
};


export type MutationProcessFranConnectChangesArgs = {
  franConnectSyncDto: FranConnectSyncProcessDto;
};


export type MutationPublishPageArgs = {
  pageId: Scalars['Int']['input'];
};


export type MutationRemovePageRevisionArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemovePageRevisionSchemaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResetPasswordArgs = {
  token: Scalars['String']['input'];
  user: ResetPasswordInputDto;
};


export type MutationResetPasswordWithTokenArgs = {
  token: Scalars['String']['input'];
  user: ResetPasswordInputDto;
};


export type MutationRestoreDeletedTtSchemaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRestoreDeletedTtSchemaFieldArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRetriggerFormSubmissionActionsArgs = {
  input: RetriggerFormSubmissionActionsInputDto;
};


export type MutationRevokeAllUserResourcesForOrganisationArgs = {
  organisationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSetBannerMessageArgs = {
  message: Scalars['String']['input'];
};


export type MutationSyncGoogleAccountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUnpublishPageArgs = {
  pageId: Scalars['Int']['input'];
};


export type MutationUpdateAllCampaignPagesOptInStatusesArgs = {
  campaignPagesOptInStatusAllUpdateDto: CampaignPagesOptInStatusAllUpdateDto;
};


export type MutationUpdateBrandArgs = {
  brand: UpdateBrandDto;
};


export type MutationUpdateCampaignArgs = {
  updateCampaignDto: UpdateCampaignDto;
};


export type MutationUpdateCampaignPageOptInStatusesArgs = {
  campaignPagesOptInStatusUpdateDto: CampaignPagesOptInStatusUpdateDto;
};


export type MutationUpdateDashboardArgs = {
  dashboard: UpdateDashboardDto;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInputDto;
};


export type MutationUpdateFeatureFlagConfigurationArgs = {
  input: UpdateFeatureFlagConfigurationInputDto;
};


export type MutationUpdateFormArgs = {
  form: UpdateFormInputDto;
};


export type MutationUpdateFormFieldArgs = {
  formField: UpdateFormFieldInputDto;
};


export type MutationUpdateFormIntegrationActionArgs = {
  action: UpdateFormIntegrationActionDto;
};


export type MutationUpdateFormIntegrationPagesArgs = {
  formIntegrationId: Scalars['Int']['input'];
  pageIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateIntegrationArgs = {
  integration: UpdateIntegrationDto;
};


export type MutationUpdateOrganisationArgs = {
  organisation: UpdateOrganisationDto;
};


export type MutationUpdatePageArgs = {
  page: UpdatePageDto;
};


export type MutationUpdatePageSeoSettingsArgs = {
  page: UpdatePageSeoSettingsDto;
};


export type MutationUpdatePreferredLocaleArgs = {
  locale: SupportedLocale;
};


export type MutationUpdateRedirectArgs = {
  redirect: UpdateRedirectEntityDto;
};


export type MutationUpdateSiteArgs = {
  updateSiteDto: UpdateSiteDto;
};


export type MutationUpdateSiteFormNotificationEmailsArgs = {
  input: UpdateSiteFormNotificationEmailsInputDto;
};


export type MutationUpdateSortOrderArgs = {
  sortOrder: UpdateFormFieldSortOrderDto;
};


export type MutationUpdateTtSchemaArgs = {
  updateTTSchemaInput: UpdateTtSchemaInput;
};


export type MutationUpdateTtSchemaFieldArgs = {
  updateTTSchemaFieldDto: UpdateTtSchemaFieldDto;
};


export type MutationUpdateTtSchemaFieldOrderArgs = {
  updateTTSchemaFieldSortOrderInput: TtSchemaFieldSortOrderInput;
};


export type MutationUpdateTtSchemaWrapperArgs = {
  updateTTSchemaWrapperInput: UpdateTtSchemaWrapperInput;
};


export type MutationUpdateTemplateArgs = {
  updateTemplateDto: UpdateTemplateInputDto;
};


export type MutationUpdateUserWithTokenArgs = {
  token: Scalars['String']['input'];
  user: UpdateUserInputDto;
};

export type NumberOfLeads = {
  __typename?: 'NumberOfLeads';
  count: Scalars['Int']['output'];
  percentChange?: Maybe<Scalars['Int']['output']>;
};

export type OrganisationBrandsPaginationParams = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Restrict paginated entities to those the user has a particular role on */
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type OrganisationDomainsPaginationParams = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationEntityDto = {
  __typename?: 'OrganisationEntityDto';
  brandsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sites: PaginatedSites;
};


export type OrganisationEntityDtoSitesArgs = {
  paginationParams: PaginationParam;
};

export type OrganisationUserResourcesPaginationParams = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Restrict paginated entities to those the user has a particular role on */
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  userId: Scalars['Int']['input'];
};

export type OrganisationUsersPaginationParams = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Restrict paginated entities to those the user has a particular role on */
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type PageCloneResult = {
  __typename?: 'PageCloneResult';
  success: Scalars['Boolean']['output'];
};

export type PageEntityDto = {
  __typename?: 'PageEntityDto';
  allowCrawling?: Maybe<Scalars['Boolean']['output']>;
  brand: BrandEntityDto;
  brandId: Scalars['Int']['output'];
  breadcrumbs: Array<Breadcrumb>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  campaignParent?: Maybe<PageEntityDto>;
  children: Array<PageEntityDto>;
  childrenCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customScriptBody?: Maybe<Scalars['String']['output']>;
  customScriptHead?: Maybe<Scalars['String']['output']>;
  draftCustomFields?: Maybe<PageRevisionEntityDto>;
  draftRevision?: Maybe<PageRevisionEntityDto>;
  excludeFromSitemap?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lang: Scalars['String']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageType?: Maybe<TtSchemaEntityDto>;
  parent?: Maybe<PageEntityDto>;
  publishedCustomFields?: Maybe<PageRevisionEntityDto>;
  publishedRevision?: Maybe<PageRevisionEntityDto>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  site: SiteEntityDto;
  sitePath?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  template?: Maybe<TemplateEntityDto>;
  templateId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
  urlSegment: Scalars['String']['output'];
};

export enum PageOrder {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum PageOrderDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type PageRevisionEntityDto = {
  __typename?: 'PageRevisionEntityDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  page?: Maybe<PageEntityDto>;
  references?: Maybe<Scalars['JSON']['output']>;
  resolvedReferences: Array<ResolvedReferenceDto>;
  schema: Array<PageRevisionSchemaEntityDto>;
  type: PageRevisionType;
};


export type PageRevisionEntityDtoSchemaArgs = {
  block?: InputMaybe<Scalars['Int']['input']>;
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRevisionReferencesWithRevisionSchemas = {
  id: Scalars['Int']['input'];
  properties?: InputMaybe<Array<PageRevisionSchemaPropertiesInput>>;
  references?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageRevisionSchemaEntityDto = {
  __typename?: 'PageRevisionSchemaEntityDto';
  anchorId?: Maybe<Scalars['String']['output']>;
  campaign: Scalars['Boolean']['output'];
  hideBlockForCampaignPlaceholders?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['Int']['output'];
  inFooter?: Maybe<Scalars['Boolean']['output']>;
  inHeader?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<PageRevisionSchemaProperties>>;
  schemaBlockId?: Maybe<Scalars['Int']['output']>;
  sortOrder: Scalars['Int']['output'];
  template?: Maybe<TemplateEntityDto>;
  ttschema?: Maybe<TtSchemaEntityDto>;
};


export type PageRevisionSchemaEntityDtoTtschemaArgs = {
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRevisionSchemaInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['Boolean']['input']>;
  hideBlockForCampaignPlaceholders?: InputMaybe<Array<Scalars['Int']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  properties: Array<PageRevisionSchemaPropertiesInput>;
  schemaBlockId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
  ttschemaId?: InputMaybe<Scalars['Int']['input']>;
};

export type PageRevisionSchemaProperties = {
  __typename?: 'PageRevisionSchemaProperties';
  dynamicReference?: Maybe<Scalars['String']['output']>;
  fieldId: Scalars['Int']['output'];
  isDynamic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
  valueReferences?: Maybe<Array<PageRevisionSchemaPropertyValueReference>>;
};

export type PageRevisionSchemaPropertiesInput = {
  dynamicReference?: InputMaybe<Scalars['String']['input']>;
  fieldId: Scalars['Int']['input'];
  isDynamic?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
  valueReferences?: InputMaybe<Array<PageRevisionSchemaPropertyValueReferenceInput>>;
};

export type PageRevisionSchemaPropertyValueReference = {
  __typename?: 'PageRevisionSchemaPropertyValueReference';
  referenceId: Scalars['String']['output'];
};

export type PageRevisionSchemaPropertyValueReferenceInput = {
  referenceId: Scalars['String']['input'];
};

export enum PageRevisionType {
  CustomFields = 'CustomFields',
  Page = 'Page',
  Template = 'Template'
}

export type PageTemplateUsageDto = {
  __typename?: 'PageTemplateUsageDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PaginatedAuditLogs = {
  __typename?: 'PaginatedAuditLogs';
  items: Array<AuditLogEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedBrands = {
  __typename?: 'PaginatedBrands';
  items: Array<BrandEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedCampaignPages = {
  __typename?: 'PaginatedCampaignPages';
  items: Array<CampaignPageEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedCampaigns = {
  __typename?: 'PaginatedCampaigns';
  items: Array<CampaignEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedDashboards = {
  __typename?: 'PaginatedDashboards';
  items: Array<DashboardEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedDomains = {
  __typename?: 'PaginatedDomains';
  items: Array<DomainEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedFormFields = {
  __typename?: 'PaginatedFormFields';
  items: Array<FormFieldEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedFormIntegrations = {
  __typename?: 'PaginatedFormIntegrations';
  items: Array<FormIntegrationEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedFormSubmissions = {
  __typename?: 'PaginatedFormSubmissions';
  items: Array<FormSubmissionEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedForms = {
  __typename?: 'PaginatedForms';
  items: Array<FormEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedGlofoxFormLeads = {
  __typename?: 'PaginatedGlofoxFormLeads';
  items: Array<GlofoxFormSubmission>;
  total: Scalars['Int']['output'];
};

export type PaginatedGmbLocationMappings = {
  __typename?: 'PaginatedGmbLocationMappings';
  items: Array<GmbLocationMappingEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedGmbLocations = {
  __typename?: 'PaginatedGmbLocations';
  items: Array<GmbLocationEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedGoogleAccounts = {
  __typename?: 'PaginatedGoogleAccounts';
  items: Array<GoogleAccountEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedGoogleAnalyticsAccounts = {
  __typename?: 'PaginatedGoogleAnalyticsAccounts';
  items: Array<GoogleAnalyticsAccountDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedGoogleAnalyticsProperties = {
  __typename?: 'PaginatedGoogleAnalyticsProperties';
  items: Array<GoogleAnalyticsPropertyDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedIntegration = {
  __typename?: 'PaginatedIntegration';
  items: Array<IntegrationDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedMetaAccounts = {
  __typename?: 'PaginatedMetaAccounts';
  items: Array<MetaAccountEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedOrganisations = {
  __typename?: 'PaginatedOrganisations';
  items: Array<OrganisationEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedPages = {
  __typename?: 'PaginatedPages';
  items: Array<PageEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedPendingImagesForAltTextGeneration = {
  __typename?: 'PaginatedPendingImagesForAltTextGeneration';
  items: Array<PendingImageForAltTextGeneration>;
  total: Scalars['Int']['output'];
};

export type PaginatedPublicPageDto = {
  __typename?: 'PaginatedPublicPageDto';
  items: Array<PublicPageEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedRedirects = {
  __typename?: 'PaginatedRedirects';
  items: Array<RedirectEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedRoles = {
  __typename?: 'PaginatedRoles';
  items: Array<RoleEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedSites = {
  __typename?: 'PaginatedSites';
  items: Array<SiteEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedTtSchemaFields = {
  __typename?: 'PaginatedTTSchemaFields';
  items: Array<TtSchemaFieldEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedTtSchemaUsages = {
  __typename?: 'PaginatedTTSchemaUsages';
  items: Array<TtSchemaUsagesResult>;
  total: Scalars['Int']['output'];
};

export type PaginatedTtSchemaWrappers = {
  __typename?: 'PaginatedTTSchemaWrappers';
  items: Array<TtSchemaWrapperEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedTtSchemas = {
  __typename?: 'PaginatedTTSchemas';
  items: Array<TtSchemaEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedTemplates = {
  __typename?: 'PaginatedTemplates';
  items: Array<TemplateEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedUserResources = {
  __typename?: 'PaginatedUserResources';
  items: Array<UserResourceEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  items: Array<UserEntityDto>;
  total: Scalars['Int']['output'];
};

export type PaginatedUsersWithRoles = {
  __typename?: 'PaginatedUsersWithRoles';
  items: Array<UserWithRoles>;
  total: Scalars['Int']['output'];
};

export type PaginationParam = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  /** Restrict paginated entities to those the user has a particular role on */
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type PendingImageForAltTextGeneration = {
  __typename?: 'PendingImageForAltTextGeneration';
  assetId: Scalars['Int']['output'];
  draftCustomFieldsId?: Maybe<Scalars['Int']['output']>;
  draftRevisionId?: Maybe<Scalars['Int']['output']>;
  images: Array<AltTextPendingImage>;
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum PresentationType {
  CheckboxGroup = 'CheckboxGroup',
  Dropdown = 'Dropdown',
  RadioButtonGroup = 'RadioButtonGroup'
}

export type PrimaryDomainDto = {
  __typename?: 'PrimaryDomainDto';
  alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  path?: Maybe<Scalars['String']['output']>;
  robots: Scalars['String']['output'];
  siteDomains: Array<SiteDomainDto>;
  sitemap: Scalars['String']['output'];
  ssl: Scalars['Boolean']['output'];
  verification: Scalars['Boolean']['output'];
};

export type PublicPageCampaignDto = {
  __typename?: 'PublicPageCampaignDto';
  id: Scalars['Int']['output'];
};

export type PublicPageEntityDto = {
  __typename?: 'PublicPageEntityDto';
  allowCrawling?: Maybe<Scalars['Boolean']['output']>;
  /** Campaigns this page is currently opted in to */
  campaigns: Array<PublicPageCampaignDto>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customProperties: Scalars['JSONObject']['output'];
  customScriptBody?: Maybe<Scalars['String']['output']>;
  customScriptHead?: Maybe<Scalars['String']['output']>;
  excludeFromSitemap?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sitePath?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
  urlSegment?: Maybe<Scalars['String']['output']>;
};

export type PublicPagesOrderByDto = {
  direction?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
};

export type PublishPageResult = {
  __typename?: 'PublishPageResult';
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  TTSchema: TtSchemaEntityDto;
  adminSubmissions: PaginatedFormSubmissions;
  assetList: Array<AssetEntityDto>;
  auditLogs: PaginatedAuditLogs;
  /** Get the current dashboard banner message */
  bannerMessage?: Maybe<Scalars['String']['output']>;
  brand: BrandEntityDto;
  brands: PaginatedBrands;
  campaign: CampaignEntityDto;
  campaignPages: PaginatedCampaignPages;
  campaignPlaceholders: Array<CampaignPlaceholderDto>;
  campaigns: PaginatedCampaigns;
  checkOverlappingCampaignPages: CampaignPageUsageResult;
  checkPageUsagesInCampaigns?: Maybe<Array<CampaignEntityDto>>;
  checkTTSchemaUsages: PaginatedTtSchemaUsages;
  dashboard: DashboardEntityDto;
  dashboards: PaginatedDashboards;
  domain: DomainEntityDto;
  errorTemplate?: Maybe<TemplateEntityDto>;
  evaluatedFeatureFlagsByNames: Array<EvaluatedFeatureFlagDto>;
  featureFlagConfiguration: FeatureFlagConfigurationDto;
  featureFlagsByNames: Array<FeatureFlagEntityDto>;
  findAll: PaginatedFormIntegrations;
  findAllOrganisationIntegrationTypes: Array<IntegrationType>;
  findOne: FormFieldEntityDto;
  findPendingImagesForAltTextGeneration: PaginatedPendingImagesForAltTextGeneration;
  form: FormEntityDto;
  forms: PaginatedForms;
  generateAltText?: Maybe<GeneratedAltText>;
  generateSiteReport: ReportResultDto;
  getListOfUsagesForCampaignTemplates: UsagesOfCampaignTemplateDto;
  getListOfUsagesForForm: UsagesOfFormDto;
  getListOfUsagesForPageTemplates: UsagesOfPageTemplateDto;
  getListOfUsagesForSWBTemplates: UsagesOfSwbdto;
  getPageTemplates: Array<TemplateEntityDto>;
  getPageTypes: Array<TtSchemaEntityDto>;
  gmbLocation: GmbLocationEntityDto;
  gmbLocationMappings: PaginatedGmbLocationMappings;
  gmbLocations: PaginatedGmbLocations;
  googleAccount: GoogleAccountEntityDto;
  googleAccounts: PaginatedGoogleAccounts;
  googleAnalyticsAccount: GoogleAnalyticsAccountDto;
  googleAnalyticsAccounts: PaginatedGoogleAnalyticsAccounts;
  googleAnalyticsProperties: PaginatedGoogleAnalyticsProperties;
  googleAnalyticsProperty: GoogleAnalyticsPropertyDto;
  integration: IntegrationDto;
  integrations: PaginatedIntegration;
  loggedInUser?: Maybe<UserEntityDto>;
  login: AuthResult;
  metaAccount: MetaAccountEntityDto;
  metaAccounts: PaginatedMetaAccounts;
  organisation: OrganisationEntityDto;
  organisationBrands: PaginatedBrands;
  organisationDomains: PaginatedDomains;
  organisationUserResources: PaginatedUserResources;
  organisationUsers: PaginatedUsers;
  organisations: PaginatedOrganisations;
  page: PageEntityDto;
  pageRevision: PageRevisionEntityDto;
  pageRevisionFromPageData: PageRevisionEntityDto;
  pageRevisionSchema: PageRevisionSchemaEntityDto;
  pages: PaginatedPages;
  publicListPages: PaginatedPublicPageDto;
  redirects: PaginatedRedirects;
  resolveReferences: Array<ResolvedReferenceDto>;
  resourceUsers: PaginatedUsersWithRoles;
  roles: PaginatedRoles;
  site: SiteEntityDto;
  siteFormNotificationEmails: Array<SiteFormNotificationEmailDto>;
  sites: PaginatedSites;
  submission: FormSubmissionEntityDto;
  submissions: PaginatedFormSubmissions;
  template: TemplateEntityDto;
  templates: PaginatedTemplates;
  ttSchemaField: TtSchemaFieldEntityDto;
  ttSchemaFields: PaginatedTtSchemaFields;
  ttSchemaWrapper: TtSchemaWrapperEntityDto;
  ttSchemaWrappers: PaginatedTtSchemaWrappers;
  ttSchemas: PaginatedTtSchemas;
  urlResolution: UrlResolutionDto;
  user?: Maybe<UserEntityDto>;
  userApiTokens: Array<UserApiTokenDto>;
  userByToken: UserEntityDto;
  userCanUpdateCampaignSomePageOptInStatuses: SomeCampaignPagesUpdateableDto;
  userMetaAccounts: UserMetaAccountsDto;
  userResource: UserResourceEntityDto;
  users: PaginatedUsers;
  validateCampaignCreateDto: ValidationResultDto;
  validateCampaignUpdateDto: ValidationResultDto;
  validateCreatePageDto: ValidationResultDto;
  validateCreateSiteDto: ValidationResultDto;
  validateSiteName: SiteNameValidationDto;
  validateTTSchemaCreateDto: ValidationResultDto;
  validateTTSchemaFieldCreateDto: ValidationResultDto;
  validateTTSchemaFieldUpdateDto: ValidationResultDto;
  validateTTSchemaUpdateDto: ValidationResultDto;
  validateTTSchemaWrapperCloneDto: ValidationResultDto;
  validateTTSchemaWrapperCreateDto: ValidationResultDto;
  validateTTSchemaWrapperUpdateDto: ValidationResultDto;
  validateUpdatePageDto: ValidationResultDto;
  validateUpdateSiteDto: ValidationResultDto;
  validateUpdateTemplateInputDto: ValidationResultDto;
};


export type QueryTtSchemaArgs = {
  id: Scalars['Int']['input'];
  includedDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminSubmissionsArgs = {
  actionStatus?: InputMaybe<SubmissionActionStatus>;
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  integrationTypes?: InputMaybe<Array<IntegrationType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  recaptchaCheckStatus?: InputMaybe<RecaptchaCheckStatus>;
  role?: InputMaybe<Role>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssetListArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAuditLogsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<AuditResourceType>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryBrandArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBrandsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCampaignPagesArgs = {
  campaignId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignPlaceholdersArgs = {
  pageIds: Array<Scalars['Int']['input']>;
  templateIds: Array<Scalars['Int']['input']>;
};


export type QueryCampaignsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  endsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  siteId: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CampaignStatus>;
  statuses?: InputMaybe<Array<CampaignStatus>>;
  type?: InputMaybe<CampaignType>;
};


export type QueryCheckOverlappingCampaignPagesArgs = {
  campaignId: Scalars['Int']['input'];
  pageId: Scalars['Int']['input'];
};


export type QueryCheckPageUsagesInCampaignsArgs = {
  pageId: Scalars['Int']['input'];
};


export type QueryCheckTtSchemaUsagesArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  schemaId: Scalars['Int']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  ttSchemaWrapperId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashboardArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashboardsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryErrorTemplateArgs = {
  domain: Scalars['String']['input'];
  errorType: ErrorTemplateType;
  path: Scalars['String']['input'];
};


export type QueryEvaluatedFeatureFlagsByNamesArgs = {
  context?: InputMaybe<FeatureFlagEvaluationContextInputDto>;
  names: Array<FeatureFlagName>;
};


export type QueryFeatureFlagConfigurationArgs = {
  name: FeatureFlagName;
};


export type QueryFeatureFlagsByNamesArgs = {
  names: Array<FeatureFlagName>;
};


export type QueryFindAllArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryFindAllOrganisationIntegrationTypesArgs = {
  organisationId: Scalars['Int']['input'];
};


export type QueryFindOneArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindPendingImagesForAltTextGenerationArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  siteId: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  ttSchemaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFormsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  siteId: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryGenerateAltTextArgs = {
  imageUrls: Array<Scalars['String']['input']>;
};


export type QueryGenerateSiteReportArgs = {
  report: SiteReportRequestDto;
};


export type QueryGetListOfUsagesForCampaignTemplatesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetListOfUsagesForFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetListOfUsagesForPageTemplatesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetListOfUsagesForSwbTemplatesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetPageTemplatesArgs = {
  pageIds: Array<Scalars['Int']['input']>;
};


export type QueryGetPageTypesArgs = {
  pageIds: Array<Scalars['Int']['input']>;
};


export type QueryGmbLocationArgs = {
  gmbName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGmbLocationsArgs = {
  paginationParam: GmbLocationPaginationParams;
};


export type QueryGoogleAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGoogleAccountsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryGoogleAnalyticsAccountArgs = {
  accountId: Scalars['String']['input'];
  googleAccountId: Scalars['Int']['input'];
};


export type QueryGoogleAnalyticsAccountsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  googleAccountId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryGoogleAnalyticsPropertiesArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  googleAccountId: Scalars['Int']['input'];
  googleAnalyticsAccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryGoogleAnalyticsPropertyArgs = {
  googleAccountId: Scalars['Int']['input'];
  propertyId: Scalars['String']['input'];
};


export type QueryIntegrationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIntegrationsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  type?: InputMaybe<IntegrationType>;
};


export type QueryLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryMetaAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMetaAccountsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryOrganisationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganisationBrandsArgs = {
  paginationParams: OrganisationBrandsPaginationParams;
};


export type QueryOrganisationDomainsArgs = {
  paginationParams: OrganisationDomainsPaginationParams;
};


export type QueryOrganisationUserResourcesArgs = {
  paginationParams: OrganisationUserResourcesPaginationParams;
};


export type QueryOrganisationUsersArgs = {
  paginationParams: OrganisationUsersPaginationParams;
};


export type QueryOrganisationsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryPageArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageRevisionArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  pageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageRevisionFromPageDataArgs = {
  pageData: PageRevisionReferencesWithRevisionSchemas;
};


export type QueryPageRevisionSchemaArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPagesArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  exclude?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeRecursive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  order?: InputMaybe<PageOrder>;
  orderDirection?: InputMaybe<PageOrderDirection>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  pageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireAllowCrawling?: InputMaybe<Scalars['Boolean']['input']>;
  requirePageTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
  schemaTypeId?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicListPagesArgs = {
  domain: Scalars['String']['input'];
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitPageAncestorId?: InputMaybe<Scalars['Int']['input']>;
  limitPageId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limitPageParentId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PublicPagesOrderByDto>;
  pageType: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryRedirectsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryResolveReferencesArgs = {
  pageId?: InputMaybe<Scalars['Int']['input']>;
  references: Array<UnresolvedReferenceDto>;
};


export type QueryResourceUsersArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['Int']['input'];
  resourceIdentifier: Scalars['String']['input'];
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QuerySiteArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySiteFormNotificationEmailsArgs = {
  siteId: Scalars['Int']['input'];
};


export type QuerySitesArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireAnalyticsConfig?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QuerySubmissionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubmissionsArgs = {
  actionStatus?: InputMaybe<SubmissionActionStatus>;
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  recaptchaCheckStatus?: InputMaybe<RecaptchaCheckStatus>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTemplatesArgs = {
  campaign?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  order?: InputMaybe<TemplateOrder>;
  orderDirection?: InputMaybe<TemplateOrderDirection>;
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  siteId: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  type?: InputMaybe<TemplateType>;
  types?: InputMaybe<Array<TemplateType>>;
};


export type QueryTtSchemaFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTtSchemaFieldsArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  lifecycleStatus?: InputMaybe<TtEntityLifecycleStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  ttSchemaId: Scalars['Int']['input'];
};


export type QueryTtSchemaWrapperArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTtSchemaWrappersArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryTtSchemasArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  lifecycleStatus?: InputMaybe<TtEntityLifecycleStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  ttSchemaWrapperId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TtSchemaType>;
  visibilities?: InputMaybe<Array<TtSchemaVisibility>>;
};


export type QueryUrlResolutionArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserByTokenArgs = {
  token: Scalars['String']['input'];
  type: UserVerificationTokenType;
};


export type QueryUserCanUpdateCampaignSomePageOptInStatusesArgs = {
  campaignId: Scalars['Int']['input'];
};


export type QueryUserResourceArgs = {
  id: Scalars['Float']['input'];
};


export type QueryUsersArgs = {
  conditions?: InputMaybe<Scalars['JSONObject']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryValidateCampaignCreateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateCampaignUpdateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateCreatePageDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateCreateSiteDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateSiteNameArgs = {
  organisationId: Scalars['Int']['input'];
  siteName: Scalars['String']['input'];
};


export type QueryValidateTtSchemaCreateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaFieldCreateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaFieldUpdateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaUpdateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaWrapperCloneDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaWrapperCreateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateTtSchemaWrapperUpdateDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateUpdatePageDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateUpdateSiteDtoArgs = {
  validationInput: ValidationInputDto;
};


export type QueryValidateUpdateTemplateInputDtoArgs = {
  validationInput: ValidationInputDto;
};

export enum RecaptchaCheckStatus {
  Failure = 'Failure',
  NotRun = 'NotRun',
  Success = 'Success'
}

export type RedirectEntityDto = {
  __typename?: 'RedirectEntityDto';
  fromPath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  redirectDomain?: Maybe<Scalars['String']['output']>;
  redirectHitCount: Scalars['Float']['output'];
  site: ToPageEntityDto;
  status: RedirectStatus;
  toPage?: Maybe<ToPageEntityDto>;
  toType: RedirectToType;
  toUrl?: Maybe<Scalars['String']['output']>;
  type: RedirectType;
};

export enum RedirectStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum RedirectToType {
  Page = 'Page',
  Url = 'Url'
}

export enum RedirectType {
  Permanent = 'Permanent',
  Temporary = 'Temporary'
}

export enum RefreshTokenStatus {
  Expired = 'EXPIRED',
  Ok = 'OK'
}

export type ReportResultDto = {
  __typename?: 'ReportResultDto';
  stats: Array<ReportStatDto>;
};

export type ReportStatDto = {
  __typename?: 'ReportStatDto';
  data: Scalars['JSON']['output'];
  type: ReportStatType;
};

export type ReportStatRequest = {
  type: ReportStatType;
};

export enum ReportStatType {
  AgeDistribution = 'AgeDistribution',
  AverageDailyLeads = 'AverageDailyLeads',
  AverageLeadsPerPage = 'AverageLeadsPerPage',
  AverageSessionDuration = 'AverageSessionDuration',
  ConversionEvents = 'ConversionEvents',
  ConversionRate = 'ConversionRate',
  DeviceDistribution = 'DeviceDistribution',
  FormSubmissions = 'FormSubmissions',
  GenderDistribution = 'GenderDistribution',
  GlofoxLeads = 'GlofoxLeads',
  GlofoxTotalJoins = 'GlofoxTotalJoins',
  GlofoxTotalLeads = 'GlofoxTotalLeads',
  LeadSources = 'LeadSources',
  LeadSourcesSession = 'LeadSourcesSession',
  LeadsByTime = 'LeadsByTime',
  NumberOfLeads = 'NumberOfLeads',
  PricingConversions = 'PricingConversions',
  TopClicked = 'TopClicked',
  TopLeadsPages = 'TopLeadsPages',
  TotalLeadsSeries = 'TotalLeadsSeries',
  TotalUsers = 'TotalUsers'
}

export type ResetPasswordInputDto = {
  password: Scalars['String']['input'];
};

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  success: Scalars['Boolean']['output'];
};

export type ResolvedReferenceDto = {
  __typename?: 'ResolvedReferenceDto';
  dynamicReference: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type RetriggerFormSubmissionActionsInputDto = {
  submissionActionStatus?: InputMaybe<Array<SubmissionActionStatus>>;
  submissionIds: Array<Scalars['Int']['input']>;
};

export type RetriggerFormSubmissionActionsResponseDto = {
  __typename?: 'RetriggerFormSubmissionActionsResponseDto';
  success: Scalars['Boolean']['output'];
};

export type RevisionSchemaSchemaDefinitionDto = {
  fields: Array<RevisionSchemaSchemaFieldDto>;
  schemas: Array<RevisionSchemaSchemaDto>;
};

export type RevisionSchemaSchemaDto = {
  id: Scalars['Int']['input'];
  type: TtSchemaType;
};

export type RevisionSchemaSchemaFieldDto = {
  hasMultipleValues: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  schemaId: Scalars['Int']['input'];
  schemaTypeId?: InputMaybe<Scalars['Int']['input']>;
  type: TtSchemaFieldType;
};

export type RevokeAllUserResourcesOnOrganisationResult = {
  __typename?: 'RevokeAllUserResourcesOnOrganisationResult';
  success: Scalars['Boolean']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  None = 'NONE',
  Owner = 'OWNER',
  PowerEditor = 'POWER_EDITOR',
  Viewer = 'VIEWER'
}

export type RoleEntityDto = {
  __typename?: 'RoleEntityDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
};

export type SchemaBlockEntityDto = {
  __typename?: 'SchemaBlockEntityDto';
  id: Scalars['Int']['output'];
};

export type SchemaFieldMappingInput = {
  sourceFieldId: Scalars['Int']['input'];
  targetFieldId: Scalars['Int']['input'];
};

export type SchemaMappingInput = {
  fieldPathMappings: Array<SchemaFieldMappingInput>;
  sourceSchemaId: Scalars['Int']['input'];
  targetSchemaId: Scalars['Int']['input'];
};

export type SendgridEmailFrom = {
  __typename?: 'SendgridEmailFrom';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SiteConfigDto = {
  __typename?: 'SiteConfigDto';
  googleAnalytics?: Maybe<SiteGoogleAnalyticsConfig>;
  integrations?: Maybe<SiteIntegrationConfigDto>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SiteDomainConfigDto = {
  __typename?: 'SiteDomainConfigDto';
  alias?: Maybe<Array<Scalars['String']['output']>>;
  domainName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  ssl: Scalars['Boolean']['output'];
  verification: Scalars['Boolean']['output'];
};

export type SiteDomainConfigurationDto = {
  domainId: Scalars['Int']['input'];
};

export type SiteDomainDto = {
  __typename?: 'SiteDomainDto';
  domainEntity?: Maybe<DomainEntityDto>;
  path?: Maybe<Scalars['String']['output']>;
  siteEntity?: Maybe<SiteEntityDto>;
};

export type SiteEntityDto = {
  __typename?: 'SiteEntityDto';
  brand: BrandEntityDto;
  config?: Maybe<SiteConfigDto>;
  customScriptBody: Scalars['String']['output'];
  customScriptHead: Scalars['String']['output'];
  domains: Array<DomainEntityDto>;
  error404Template?: Maybe<TemplateEntityDto>;
  error500Template?: Maybe<TemplateEntityDto>;
  footerTemplate?: Maybe<TemplateEntityDto>;
  glofoxFormSubmissions: PaginatedGlofoxFormLeads;
  headerTemplate?: Maybe<TemplateEntityDto>;
  homepage?: Maybe<PageEntityDto>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pages: Array<PageEntityDto>;
  primaryDomain?: Maybe<PrimaryDomainDto>;
  siteDomainsWithPath: Array<SiteDomainConfigDto>;
  templates: Array<TemplateEntityDto>;
  thumbnailImageUrls?: Maybe<DeviceScreenshotDto>;
  timezone?: Maybe<Scalars['String']['output']>;
  ttSchemaWrapper?: Maybe<TtSchemaWrapperEntityDto>;
  webhooks: Array<Scalars['String']['output']>;
};


export type SiteEntityDtoGlofoxFormSubmissionsArgs = {
  paginationParams: GlofoxFormLeadsPaginationParams;
};


export type SiteEntityDtoTemplatesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TemplateType>;
};

export type SiteFormNotificationEmailDto = {
  __typename?: 'SiteFormNotificationEmailDto';
  email: Scalars['String']['output'];
};

export type SiteGoogleAnalyticsConfig = {
  __typename?: 'SiteGoogleAnalyticsConfig';
  accountId?: Maybe<Scalars['String']['output']>;
  googleAccountId?: Maybe<Scalars['Int']['output']>;
  propertyId?: Maybe<Scalars['String']['output']>;
};

export type SiteIntegrationConfigDto = {
  __typename?: 'SiteIntegrationConfigDto';
  glofox?: Maybe<SiteIntegrationGlofoxConfigDto>;
};

export type SiteIntegrationGlofixReportingConfigDto = {
  __typename?: 'SiteIntegrationGlofixReportingConfigDto';
  apiUrl?: Maybe<Scalars['String']['output']>;
  basicAuthToken?: Maybe<Scalars['String']['output']>;
};

export type SiteIntegrationGlofoxConfigDto = {
  __typename?: 'SiteIntegrationGlofoxConfigDto';
  reporting?: Maybe<SiteIntegrationGlofixReportingConfigDto>;
};

export type SiteNameValidationDto = {
  __typename?: 'SiteNameValidationDto';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SiteReportRequestDto = {
  endDate?: Scalars['String']['input'];
  pageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: Scalars['String']['input'];
  stats?: Array<ReportStatRequest>;
};

export type SomeCampaignPagesUpdateableDto = {
  __typename?: 'SomeCampaignPagesUpdateableDto';
  updateable: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum SubmissionActionStatus {
  Failed = 'Failed',
  Missing = 'Missing'
}

export enum SupportedLocale {
  EnUs = 'EnUs',
  EsEs = 'EsEs'
}

export type SyncAllGoogleAccountsResult = {
  __typename?: 'SyncAllGoogleAccountsResult';
  accountsCount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SyncResult = {
  __typename?: 'SyncResult';
  success: Scalars['Boolean']['output'];
};

export enum TtEntityLifecycleStatus {
  Active = 'Active',
  All = 'All',
  Deleted = 'Deleted'
}

export type TtSchemaDeleteResult = {
  __typename?: 'TTSchemaDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type TtSchemaEntityDto = {
  __typename?: 'TTSchemaEntityDto';
  deletedAt?: Maybe<Scalars['String']['output']>;
  fields: Array<TtSchemaFieldEntityDto>;
  id: Scalars['Int']['output'];
  /** Technical name */
  name: Scalars['String']['output'];
  subSchemas: Array<TtSchemaEntityDto>;
  thumbnailImageUrls?: Maybe<DeviceScreenshotDto>;
  titlePlural: Scalars['String']['output'];
  titleSingular: Scalars['String']['output'];
  ttschemaWrapper: TtSchemaWrapperEntityDto;
  type: TtSchemaType;
  visibility: TtSchemaVisibility;
};

export type TtSchemaFieldDeleteResult = {
  __typename?: 'TTSchemaFieldDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type TtSchemaFieldEntityDto = {
  __typename?: 'TTSchemaFieldEntityDto';
  TTSchema: TtSchemaEntityDto;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  hasMultipleValues: Scalars['Boolean']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  type: TtSchemaFieldType;
  typeDefinition?: Maybe<Scalars['JSON']['output']>;
  typeTTSchema?: Maybe<TtSchemaEntityDto>;
  visibility: TtSchemaFieldVisibility;
};

export type TtSchemaFieldSortOrderDto = {
  id: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type TtSchemaFieldSortOrderInput = {
  fields: Array<TtSchemaFieldSortOrderDto>;
  id: Scalars['Int']['input'];
};

export type TtSchemaFieldSortOrderUpdateResult = {
  __typename?: 'TTSchemaFieldSortOrderUpdateResult';
  success: Scalars['Boolean']['output'];
};

export enum TtSchemaFieldType {
  Datetime = 'Datetime',
  Form = 'Form',
  GmbLocation = 'GmbLocation',
  Image = 'Image',
  Instagram = 'Instagram',
  Link = 'Link',
  Page = 'Page',
  RichText = 'RichText',
  Schema = 'Schema',
  Text = 'Text',
  TextArea = 'TextArea',
  TextSelect = 'TextSelect'
}

export enum TtSchemaFieldVisibility {
  All = 'All',
  Hidden = 'Hidden',
  SiteAdminOnly = 'SiteAdminOnly'
}

export enum TtSchemaType {
  Block = 'Block',
  Campaign = 'Campaign',
  Component = 'Component',
  Object = 'Object',
  Page = 'Page',
  Schema = 'Schema'
}

export type TtSchemaUsagesResult = {
  __typename?: 'TTSchemaUsagesResult';
  pages: Array<PageEntityDto>;
  schemas: Array<TtSchemaEntityDto>;
  templates: Array<TemplateEntityDto>;
};

export enum TtSchemaVisibility {
  All = 'All',
  Hidden = 'Hidden',
  SiteAdminOnly = 'SiteAdminOnly'
}

export type TtSchemaWrapperDeleteResult = {
  __typename?: 'TTSchemaWrapperDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type TtSchemaWrapperEntityDto = {
  __typename?: 'TTSchemaWrapperEntityDto';
  deletable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organisation: OrganisationEntityDto;
  siteId?: Maybe<Scalars['Int']['output']>;
  ttschemas: Array<TtSchemaEntityDto>;
};


export type TtSchemaWrapperEntityDtoTtschemasArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TtSchemaType>;
};

export type TtSchemaWrapperInput = {
  name: Scalars['String']['input'];
  organisationId: Scalars['Int']['input'];
};

export type TemplateEntityDto = {
  __typename?: 'TemplateEntityDto';
  campaign?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  draftRevision?: Maybe<PageRevisionEntityDto>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pageType?: Maybe<TtSchemaEntityDto>;
  publishedRevision?: Maybe<PageRevisionEntityDto>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  site: SiteEntityDto;
  thumbnailImageUrls?: Maybe<DeviceScreenshotDto>;
  type: TemplateType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TemplateMappingInput = {
  sourceTemplateId: Scalars['Int']['input'];
  targetTemplateId: Scalars['Int']['input'];
};

export enum TemplateOrder {
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export enum TemplateOrderDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum TemplateType {
  Campaign = 'Campaign',
  FixedPageLayout = 'FixedPageLayout',
  SiteWideBlock = 'SiteWideBlock',
  StarterPageLayout = 'StarterPageLayout'
}

export type ToPageEntityDto = {
  __typename?: 'ToPageEntityDto';
  id: Scalars['Int']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  urlPath?: Maybe<Scalars['String']['output']>;
  urlSegment?: Maybe<Scalars['String']['output']>;
};

export type TotalLeadsDataAverageDaily = {
  __typename?: 'TotalLeadsDataAverageDaily';
  average: Scalars['Int']['output'];
  percentChange?: Maybe<Scalars['Int']['output']>;
};

export type TotalLeadsDataAveragePerPage = {
  __typename?: 'TotalLeadsDataAveragePerPage';
  average: Scalars['Int']['output'];
  percentChange?: Maybe<Scalars['Int']['output']>;
};

export type UrlRedirectEntityDto = {
  __typename?: 'URLRedirectEntityDto';
  target: Scalars['String']['output'];
  type: RedirectType;
};

export type UnpublishPageResult = {
  __typename?: 'UnpublishPageResult';
  success: Scalars['Boolean']['output'];
};

export type UnresolvedReferenceDto = {
  dynamicReference: Scalars['String']['input'];
  pageId?: InputMaybe<Scalars['Int']['input']>;
  reference: Scalars['JSON']['input'];
};

export type UpdateBrandDto = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCampaignDto = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Float']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pageMetadata?: InputMaybe<CampaignPageMetadataCreateDto>;
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  placeholderTemplates?: InputMaybe<Array<CampaignPlaceholderTemplateInputDto>>;
  regenerateSubpages?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateDashboardDto = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  panels?: InputMaybe<Array<DashboardPanelConfigInput>>;
};

export type UpdateFeatureFlagConfigurationInputDto = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  enableTime?: InputMaybe<Scalars['DateTime']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: FeatureFlagName;
  /** Feature-specific configuration options */
  options: Scalars['JSON']['input'];
};

export type UpdateFeatureFlagInputDto = {
  name: FeatureFlagName;
  /** Configuration options for the feature flag */
  options: Scalars['JSON']['input'];
};

export type UpdateFormFieldInputDto = {
  autocomplete?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<FormFieldConfigInput>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<FormFieldType>;
};

export type UpdateFormFieldSortOrderDto = {
  siteId: Scalars['Int']['input'];
  sortOrders: Scalars['JSONObject']['input'];
};

export type UpdateFormInputDto = {
  botProtectionIntegrationId?: InputMaybe<Scalars['Int']['input']>;
  enableRecaptcha?: Scalars['Boolean']['input'];
  formIdentifier?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  retentionPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  submitButtonLabel: Scalars['String']['input'];
  thankYouMessage: Scalars['String']['input'];
};

export type UpdateFormIntegrationActionDto = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledUntil?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  integration?: InputMaybe<UpdateIntegrationDto>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  specification?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateIntegrationDto = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  specification?: InputMaybe<Scalars['JSONObject']['input']>;
  type?: InputMaybe<IntegrationType>;
};

export type UpdateOrganisationDto = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdatePageDto = {
  allowCrawling?: InputMaybe<Scalars['Boolean']['input']>;
  customScriptBody?: InputMaybe<Scalars['String']['input']>;
  customScriptHead?: InputMaybe<Scalars['String']['input']>;
  draftCustomFieldsId?: InputMaybe<Scalars['Int']['input']>;
  draftRevisionId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Array<CustomPagePropertiesInput>>;
  publishedCustomFieldsId?: InputMaybe<Scalars['Int']['input']>;
  publishedRevisionId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  ttschemaId?: InputMaybe<Scalars['Int']['input']>;
  urlSegment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageSeoSettingsDto = {
  allowCrawling?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRedirectEntityDto = {
  fromPath?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RedirectStatus>;
  toPageId?: InputMaybe<Scalars['Int']['input']>;
  toType?: InputMaybe<RedirectToType>;
  toUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RedirectType>;
};

export type UpdateSiteDto = {
  customScriptBody?: InputMaybe<Scalars['String']['input']>;
  customScriptHead?: InputMaybe<Scalars['String']['input']>;
  domainConfigurations?: InputMaybe<Array<SiteDomainConfigurationDto>>;
  error404TemplateId?: InputMaybe<Scalars['Int']['input']>;
  error500TemplateId?: InputMaybe<Scalars['Int']['input']>;
  footerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  googleAccountId?: InputMaybe<Scalars['Float']['input']>;
  googleAnalyticsAccountId?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsPropertyId?: InputMaybe<Scalars['String']['input']>;
  headerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  homepageId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primaryDomainId?: InputMaybe<Scalars['Int']['input']>;
  sitePath?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSiteFormNotificationEmailsInputDto = {
  emails: Array<Scalars['String']['input']>;
  siteId: Scalars['Int']['input'];
};

export type UpdateTtSchemaFieldDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasMultipleValues?: InputMaybe<Scalars['Boolean']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  typeDefinition?: InputMaybe<Scalars['JSON']['input']>;
  visibility?: InputMaybe<TtSchemaFieldVisibility>;
};

export type UpdateTtSchemaInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  titlePlural?: InputMaybe<Scalars['String']['input']>;
  titleSingular?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<TtSchemaVisibility>;
};

export type UpdateTtSchemaWrapperInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateInputDto = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageTypeId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TemplateType>;
};

export type UpdateUserInputDto = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UrlResolutionDto = {
  __typename?: 'UrlResolutionDto';
  page?: Maybe<PageEntityDto>;
  redirect?: Maybe<UrlRedirectEntityDto>;
};

export type UsagesOfCampaignTemplateDto = {
  __typename?: 'UsagesOfCampaignTemplateDTO';
  campaigns: Array<CampaignTemplateUsageDto>;
};

export type UsagesOfFormDto = {
  __typename?: 'UsagesOfFormDTO';
  pages: Array<Scalars['String']['output']>;
  templates: Array<Scalars['String']['output']>;
};

export type UsagesOfPageTemplateDto = {
  __typename?: 'UsagesOfPageTemplateDTO';
  pages: Array<PageTemplateUsageDto>;
};

export type UsagesOfSwbdto = {
  __typename?: 'UsagesOfSWBDTO';
  pages: Array<Scalars['String']['output']>;
  templates: Array<Scalars['String']['output']>;
};

export type UserAccessDto = {
  __typename?: 'UserAccessDto';
  rules?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type UserApiTokenDto = {
  __typename?: 'UserApiTokenDto';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastAccessAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserEntityDto = {
  __typename?: 'UserEntityDto';
  access: UserAccessDto;
  email: Scalars['String']['output'];
  featureFlags: UserFeatureFlagsDto;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  impersonatingUser?: Maybe<UserEntityDto>;
  lastName: Scalars['String']['output'];
  preferredLocale: SupportedLocale;
  verified: Scalars['Boolean']['output'];
};

export type UserFeatureFlagsDto = {
  __typename?: 'UserFeatureFlagsDto';
  formSubmissionEnqueue: FormSubmissionEnqueueFlagOptionsDto;
  inputValidation: InputValidationFlagOptionsDto;
};

export type UserMetaAccountsDto = {
  __typename?: 'UserMetaAccountsDto';
  metaAccounts: Array<MetaAccountEntityDto>;
};

export type UserResourceEntityDto = {
  __typename?: 'UserResourceEntityDto';
  id: Scalars['Int']['output'];
  resourceId: Scalars['Float']['output'];
  resourceIdentifier: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  role: RoleEntityDto;
  user: UserEntityDto;
};

export type UserResourcePermissionsDto = {
  __typename?: 'UserResourcePermissionsDto';
  id: Scalars['Int']['output'];
  resourceId?: Maybe<Scalars['Int']['output']>;
  resourceIdentifier?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserRoleDto = {
  __typename?: 'UserRoleDto';
  explicit: Scalars['Boolean']['output'];
  from: UserResourceEntityDto;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum UserVerificationTokenType {
  NewUser = 'NEW_USER',
  PasswordReset = 'PASSWORD_RESET'
}

export type UserWithRoles = {
  __typename?: 'UserWithRoles';
  email: Scalars['String']['output'];
  explicitRole?: Maybe<UserRoleDto>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  primaryRole?: Maybe<UserRoleDto>;
  roles: Array<UserRoleDto>;
};

export type ValidationInputDto = {
  object: Scalars['JSON']['input'];
};

export type ValidationResultDto = {
  __typename?: 'ValidationResultDto';
  errors: Array<WrappedValidationError>;
  hasErrors: Scalars['Boolean']['output'];
};

export type WrappedValidationError = {
  __typename?: 'WrappedValidationError';
  children: Array<WrappedValidationError>;
  constraints: Scalars['JSON']['output'];
  property: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type GetBannerMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannerMessageQuery = { __typename?: 'Query', bannerMessage?: string | null };

export type SetBannerMessageMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type SetBannerMessageMutation = { __typename?: 'Mutation', setBannerMessage: boolean };

export type PresignedUrlMutationVariables = Exact<{
  asset: CreateAssetInput;
}>;


export type PresignedUrlMutation = { __typename?: 'Mutation', presignedUrl: { __typename?: 'AssetUploadResponseDto', id: number, url: string, mimeType: string, signedURL: string } };

export type GenerateAltTextQueryVariables = Exact<{
  imageUrls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateAltTextQuery = { __typename?: 'Query', generateAltText?: { __typename?: 'GeneratedAltText', results: Array<{ __typename?: 'GeneratedAltTextItem', imageUrl: string, altText: string }> } | null };

export type FindPendingImagesForAltTextGenerationQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ttSchemaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindPendingImagesForAltTextGenerationQuery = { __typename?: 'Query', findPendingImagesForAltTextGeneration: { __typename?: 'PaginatedPendingImagesForAltTextGeneration', total: number, items: Array<{ __typename?: 'PendingImageForAltTextGeneration', siteId: number, assetId: number, type: string, name: string, draftRevisionId?: number | null, draftCustomFieldsId?: number | null, images: Array<{ __typename?: 'AltTextPendingImage', imageUrl: string, currentAltText?: string | null, fileName: string, revisionSchemaId: number }> }> } };

export type BulkUpdateAltTextMutationVariables = Exact<{
  siteId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  items: Array<BulkUpdateAltTextItem> | BulkUpdateAltTextItem;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  draftRevisionId?: InputMaybe<Scalars['Int']['input']>;
  draftCustomFieldsId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkUpdateAltTextMutation = { __typename?: 'Mutation', bulkUpdateAltText: { __typename?: 'BulkUpdateAltTextResult', success: boolean, message?: string | null, updatedCount: number } };

export type GetAuditLogsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<AuditResourceType>;
  resourceId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'PaginatedAuditLogs', total: number, items: Array<{ __typename?: 'AuditLogEntityDto', id: number, createdAt: any, resourceType?: AuditResourceType | null, resourceId?: number | null, action?: AuditAction | null, detail?: string | null, detailObj: any, page?: { __typename?: 'AuditLogPageDto', id: number, name: string, siteId: number } | null, user?: { __typename?: 'AuditLogUserDto', id: number, firstName: string, lastName: string, email: string } | null, impersonatingUser?: { __typename?: 'AuditLogUserDto', id: number, firstName: string, lastName: string, email: string } | null }> } };

export type GetOrganisationBrandsQueryVariables = Exact<{
  paginationParams: OrganisationBrandsPaginationParams;
}>;


export type GetOrganisationBrandsQuery = { __typename?: 'Query', organisationBrands: { __typename?: 'PaginatedBrands', total: number, items: Array<{ __typename?: 'BrandEntityDto', id: number, name: string, sites: Array<{ __typename?: 'SiteEntityDto', id: number }> }> } };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: { __typename?: 'BrandEntityDto', id: number } };

export type UpdateBrandMutationVariables = Exact<{
  updateBrandDto: UpdateBrandDto;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandEntityDto', id: number } };

export type CreateBrandMutationVariables = Exact<{
  createBrandDto: CreateBrandDto;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'BrandEntityDto', id: number } };

export type GetBrandQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBrandQuery = { __typename?: 'Query', brand: { __typename?: 'BrandEntityDto', id: number, name: string } };

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'CampaignEntityDto', id: number, name: string, imageUrl?: string | null, type: CampaignType, consentType: CampaignConsentType, startTime?: any | null, endTime?: any | null, status: CampaignStatus, pageIds: Array<number>, pageType?: { __typename?: 'TTSchemaEntityDto', id: number } | null, site: { __typename?: 'SiteEntityDto', id: number, name: string }, campaignPageMetadata?: { __typename?: 'CampaignPageMetadataDto', metaTitle: string, metaDescription: string, allowCrawling: boolean, urlSegment: string, template: { __typename?: 'TemplateEntityDto', id: number, type: TemplateType } } | null, placeholderTemplates: Array<{ __typename?: 'CampaignPlaceholderTemplateDto', schemaBlockId: number, templateId: number }> } };

export type SiteCampaignsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  type?: InputMaybe<CampaignType>;
  status?: InputMaybe<CampaignStatus>;
  statuses?: InputMaybe<Array<CampaignStatus> | CampaignStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endsAfter?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SiteCampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'PaginatedCampaigns', items: Array<{ __typename?: 'CampaignEntityDto', id: number, name: string, startTime?: any | null, endTime?: any | null, imageUrl?: string | null, consentType: CampaignConsentType, status: CampaignStatus, site: { __typename?: 'SiteEntityDto', name: string } }> } };

export type CreateCampaignMutationVariables = Exact<{
  createCampaignDto: CreateCampaignDto;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'CampaignEntityDto', id: number } };

export type ValidateCampaignCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateCampaignCreateQuery = { __typename?: 'Query', validateCampaignCreateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type UpdateCampaignMutationVariables = Exact<{
  updateCampaignDto: UpdateCampaignDto;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'CampaignEntityDto', id: number } };

export type ValidateCampaignUpdateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateCampaignUpdateQuery = { __typename?: 'Query', validateCampaignUpdateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type DeleteCampaignMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign: { __typename?: 'CampaignDeleteResult', success: boolean } };

export type ForceStartCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;


export type ForceStartCampaignMutation = { __typename?: 'Mutation', forceStartCampaign: { __typename?: 'CampaignForceStartResult', success: boolean } };

export type ForceEndCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;


export type ForceEndCampaignMutation = { __typename?: 'Mutation', forceEndCampaign: { __typename?: 'CampaignForceEndResult', success: boolean } };

export type GetCampaignPlaceholdersQueryVariables = Exact<{
  pageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  templateIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCampaignPlaceholdersQuery = { __typename?: 'Query', campaignPlaceholders: Array<{ __typename?: 'CampaignPlaceholderDto', id: number, label: string, schemaBlockId: number }> };

export type GetCampaignPagesQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCampaignPagesQuery = { __typename?: 'Query', campaignPages: { __typename?: 'PaginatedCampaignPages', total: number, items: Array<{ __typename?: 'CampaignPageEntityDto', id: number, optedIn: boolean, editable: boolean, page: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, template?: { __typename?: 'TemplateEntityDto', id: number, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null } | null }, subpage?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, template?: { __typename?: 'TemplateEntityDto', id: number, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null } | null } | null }> } };

export type UpdateCampaignPagesOptInStatusMutationVariables = Exact<{
  campaignPagesOptInStatusUpdateDto: CampaignPagesOptInStatusUpdateDto;
}>;


export type UpdateCampaignPagesOptInStatusMutation = { __typename?: 'Mutation', updateCampaignPageOptInStatuses: { __typename?: 'CampaignPageOptInStatusUpdateResult', success: boolean } };

export type AnnounceCampaignMutationVariables = Exact<{
  campaignId: Scalars['Int']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AnnounceCampaignMutation = { __typename?: 'Mutation', announceCampaign: { __typename?: 'CampaignAnnouncementResult', success: boolean } };

export type UpdateAllCampaignPagesOptInStatusMutationVariables = Exact<{
  campaignPagesOptInStatusAllUpdateDto: CampaignPagesOptInStatusAllUpdateDto;
}>;


export type UpdateAllCampaignPagesOptInStatusMutation = { __typename?: 'Mutation', updateAllCampaignPagesOptInStatuses: { __typename?: 'CampaignPageOptInStatusUpdateResult', success: boolean } };

export type SomeCampaignPagesUpdateableQueryVariables = Exact<{
  campaignId: Scalars['Int']['input'];
}>;


export type SomeCampaignPagesUpdateableQuery = { __typename?: 'Query', userCanUpdateCampaignSomePageOptInStatuses: { __typename?: 'SomeCampaignPagesUpdateableDto', updateable: boolean } };

export type CheckOverlappingCampaignPagesQueryVariables = Exact<{
  pageId: Scalars['Int']['input'];
  campaignId: Scalars['Int']['input'];
}>;


export type CheckOverlappingCampaignPagesQuery = { __typename?: 'Query', checkOverlappingCampaignPages: { __typename?: 'CampaignPageUsageResult', usages?: Array<{ __typename?: 'CampaignEntityDto', name: string }> | null } };

export type GetOrganisationDomainsQueryVariables = Exact<{
  paginationParams: OrganisationDomainsPaginationParams;
}>;


export type GetOrganisationDomainsQuery = { __typename?: 'Query', organisationDomains: { __typename?: 'PaginatedDomains', total: number, items: Array<{ __typename?: 'DomainEntityDto', id: number, domainName: string, ssl: boolean, siteDomains: Array<{ __typename?: 'SiteDomainDto', siteEntity?: { __typename?: 'SiteEntityDto', id: number } | null }> }> } };

export type DeleteDomainMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDomainMutation = { __typename?: 'Mutation', deleteDomain: { __typename?: 'DomainEntityDto', id: number } };

export type CreateDomainMutationVariables = Exact<{
  createDomainDto: CreateDomainDto;
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain: { __typename?: 'DomainEntityDto', id: number } };

export type EvaluatedFeatureFlagsByNamesQueryVariables = Exact<{
  names: Array<FeatureFlagName> | FeatureFlagName;
  context?: InputMaybe<FeatureFlagEvaluationContextInputDto>;
}>;


export type EvaluatedFeatureFlagsByNamesQuery = { __typename?: 'Query', evaluatedFeatureFlagsByNames: Array<{ __typename?: 'EvaluatedFeatureFlagDto', name: FeatureFlagName, isEnabled: boolean, options: any }> };

export type FeatureFlagsByNamesQueryVariables = Exact<{
  names: Array<FeatureFlagName> | FeatureFlagName;
}>;


export type FeatureFlagsByNamesQuery = { __typename?: 'Query', featureFlagsByNames: Array<{ __typename?: 'FeatureFlagEntityDto', id: number, name: FeatureFlagName, options: any, createdAt: any, updatedAt: any }> };

export type UpdateFeatureFlagMutationVariables = Exact<{
  input: UpdateFeatureFlagInputDto;
}>;


export type UpdateFeatureFlagMutation = { __typename?: 'Mutation', updateFeatureFlag: { __typename?: 'FeatureFlagEntityDto', id: number, name: FeatureFlagName, options: any, createdAt: any, updatedAt: any } };

export type FeatureFlagConfigurationQueryVariables = Exact<{
  name: FeatureFlagName;
}>;


export type FeatureFlagConfigurationQuery = { __typename?: 'Query', featureFlagConfiguration: { __typename?: 'FeatureFlagConfigurationDto', name: FeatureFlagName, enabled: boolean, enableTime?: any | null, context: any, options: any } };

export type UpdateFeatureFlagConfigurationMutationVariables = Exact<{
  input: UpdateFeatureFlagConfigurationInputDto;
}>;


export type UpdateFeatureFlagConfigurationMutation = { __typename?: 'Mutation', updateFeatureFlagConfiguration: { __typename?: 'FeatureFlagConfigurationDto', name: FeatureFlagName, enabled: boolean, enableTime?: any | null, context: any, options: any } };

export type FeatureFlagOrganisationOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagOrganisationOptionsQuery = { __typename?: 'Query', organisations: { __typename?: 'PaginatedOrganisations', items: Array<{ __typename?: 'OrganisationEntityDto', id: number, name: string }> } };

export type FeatureFlagBrandOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagBrandOptionsQuery = { __typename?: 'Query', brands: { __typename?: 'PaginatedBrands', items: Array<{ __typename?: 'BrandEntityDto', id: number, name: string }> } };

export type FeatureFlagSiteOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagSiteOptionsQuery = { __typename?: 'Query', sites: { __typename?: 'PaginatedSites', items: Array<{ __typename?: 'SiteEntityDto', id: number, name: string }> } };

export type FeatureFlagPageOptionsQueryVariables = Exact<{
  pageName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagPageOptionsQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', items: Array<{ __typename?: 'PageEntityDto', id: number, name: string }> } };

export type FeatureFlagUserOptionsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeatureFlagUserOptionsQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUsers', items: Array<{ __typename?: 'UserEntityDto', id: number, firstName: string, lastName: string, email: string }> } };

export type CreateFormFieldMutationVariables = Exact<{
  createFormFieldInput: CreateFormFieldInputDto;
}>;


export type CreateFormFieldMutation = { __typename?: 'Mutation', createFormField: { __typename?: 'FormFieldEntityDto', id: number } };

export type FormQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type FormQuery = { __typename?: 'Query', form: { __typename?: 'FormEntityDto', id: number, name: string, fields: Array<{ __typename?: 'FormFieldEntityDto', id: number, name: string, label?: string | null, placeholder: string, type: FormFieldType, isRequired?: boolean | null, helpText?: string | null, sortOrder?: number | null, autocomplete?: string | null, config?: { __typename?: 'FormFieldConfig', customCss?: string | null, info?: string | null, defaultValue?: any | null, inputType?: FormFieldInputType | null, presentation?: PresentationType | null, validation?: { __typename?: 'FormFieldValidationConfig', constraints: Array<{ __typename?: 'FormFieldValidationConstraint', id: string, type: FormFieldConstraintType, props: any, message: string }> } | null, options?: Array<{ __typename?: 'KeyValue', id: string, key: string, value: string }> | null } | null }> } };

export type UpdateFieldSortOrderMutationVariables = Exact<{
  order: UpdateFormFieldSortOrderDto;
}>;


export type UpdateFieldSortOrderMutation = { __typename?: 'Mutation', updateSortOrder: Array<{ __typename?: 'FormFieldEntityDto', id: number, label?: string | null, placeholder: string, type: FormFieldType, isRequired?: boolean | null, helpText?: string | null, sortOrder?: number | null }> };

export type UpdateFormFieldMutationVariables = Exact<{
  updateFormFieldInput: UpdateFormFieldInputDto;
}>;


export type UpdateFormFieldMutation = { __typename?: 'Mutation', updateFormField: { __typename?: 'FormFieldEntityDto', id: number } };

export type DeleteFormFieldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFormFieldMutation = { __typename?: 'Mutation', deleteFormField: { __typename?: 'FormFieldEntityDto', id: number } };

export type RetriggerFormSubmissionActionsMutationVariables = Exact<{
  input: RetriggerFormSubmissionActionsInputDto;
}>;


export type RetriggerFormSubmissionActionsMutation = { __typename?: 'Mutation', retriggerFormSubmissionActions: { __typename?: 'RetriggerFormSubmissionActionsResponseDto', success: boolean } };

export type CreateFormMutationVariables = Exact<{
  createFormInput: CreateFormInputDto;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'FormEntityDto', id: number } };

export type UpdateFormMutationVariables = Exact<{
  form: UpdateFormInputDto;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'FormEntityDto', id: number } };

export type SiteFormsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
}>;


export type SiteFormsQuery = { __typename?: 'Query', forms: { __typename?: 'PaginatedForms', items: Array<{ __typename?: 'FormEntityDto', id: number, name: string, submitButtonLabel: string, enableRecaptcha: boolean, formIdentifier?: string | null, thankYouMessage: string, retentionPeriodDays?: number | null, lastSubmission?: any | null, botProtectionIntegration?: { __typename?: 'IntegrationDto', id: number } | null }> } };

export type FormSubmissionsQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  recaptchaCheckStatus?: InputMaybe<RecaptchaCheckStatus>;
  actionStatus?: InputMaybe<SubmissionActionStatus>;
}>;


export type FormSubmissionsQuery = { __typename?: 'Query', submissions: { __typename?: 'PaginatedFormSubmissions', total: number, items: Array<{ __typename?: 'FormSubmissionEntityDto', id: number, value: any, createdAt: string, recaptchaCheckStatus: RecaptchaCheckStatus, form?: { __typename?: 'FormEntityDto', id: number, name: string, fields: Array<{ __typename?: 'FormFieldEntityDto', id: number, name: string }> } | null, actions: Array<{ __typename?: 'FormSubmissionActionDto', id: number, name: string, pendingAt?: any | null, hasActionLog: boolean }>, actionLogs: Array<{ __typename?: 'FormSubmissionIntegrationActionLogEntityDto', isSuccess: boolean, requestData?: string | null, response: string, createdAt: any, integration?: { __typename?: 'FormSubmissionIntegrationEntityDto', name: string } | null, action: { __typename?: 'FormSubmissionIntegrationActionEntityDto', id: number, specification: any } }>, page?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null } | null }> } };

export type AdminFormSubmissionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  formId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  actionStatus?: InputMaybe<SubmissionActionStatus>;
  recaptchaCheckStatus?: InputMaybe<RecaptchaCheckStatus>;
  integrationTypes?: InputMaybe<Array<IntegrationType> | IntegrationType>;
}>;


export type AdminFormSubmissionsQuery = { __typename?: 'Query', adminSubmissions: { __typename?: 'PaginatedFormSubmissions', total: number, items: Array<{ __typename?: 'FormSubmissionEntityDto', id: number, value: any, createdAt: string, recaptchaCheckStatus: RecaptchaCheckStatus, recaptchaScore?: number | null, form?: { __typename?: 'FormEntityDto', id: number, name: string, site: { __typename?: 'SiteEntityDto', id: number, name: string }, fields: Array<{ __typename?: 'FormFieldEntityDto', id: number, name: string }> } | null, actionLogs: Array<{ __typename?: 'FormSubmissionIntegrationActionLogEntityDto', isSuccess: boolean, requestData?: string | null, response: string, createdAt: any, integration?: { __typename?: 'FormSubmissionIntegrationEntityDto', name: string } | null, action: { __typename?: 'FormSubmissionIntegrationActionEntityDto', id: number, specification: any } }>, actions: Array<{ __typename?: 'FormSubmissionActionDto', id: number, name: string, pendingAt?: any | null, hasActionLog: boolean }>, page?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null } | null }> } };

export type DeleteFormMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm: { __typename?: 'FormEntityDto', id: number } };

export type DuplicateFormMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DuplicateFormMutation = { __typename?: 'Mutation', duplicateForm: { __typename?: 'FormEntityDto', id: number } };

export type FormIntegrationsQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type FormIntegrationsQuery = { __typename?: 'Query', form: { __typename?: 'FormEntityDto', id: number, name: string, fields: Array<{ __typename?: 'FormFieldEntityDto', id: number, name: string, type: FormFieldType, label?: string | null }>, integrations: Array<{ __typename?: 'FormIntegrationEntityDto', id: number, pages: Array<{ __typename?: 'PageEntityDto', id: number, name: string, breadcrumbs: Array<{ __typename?: 'Breadcrumb', urlPath: string }> }>, actions?: Array<{ __typename?: 'FormIntegrationActionEntityDto', id: number, specification: any, disabled: boolean, disabledUntil?: any | null, integration?: { __typename?: 'IntegrationDto', id: number, name: string, type: IntegrationType } | null }> | null }> } };

export type SingleFormQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type SingleFormQuery = { __typename?: 'Query', form: { __typename?: 'FormEntityDto', id: number, name: string, botProtection: BotProtectionType, fields: Array<{ __typename?: 'FormFieldEntityDto', id: number, name: string }> } };

export type GetFormQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFormQuery = { __typename?: 'Query', form: { __typename?: 'FormEntityDto', id: number, name: string } };

export type GetListOfUsagesForFormQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListOfUsagesForFormQuery = { __typename?: 'Query', getListOfUsagesForForm: { __typename?: 'UsagesOfFormDTO', pages: Array<string>, templates: Array<string> } };

export type SiteFormNotificationEmailsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
}>;


export type SiteFormNotificationEmailsQuery = { __typename?: 'Query', siteFormNotificationEmails: Array<{ __typename?: 'SiteFormNotificationEmailDto', email: string }> };

export type UpdateSiteFormNotificationEmailsMutationVariables = Exact<{
  input: UpdateSiteFormNotificationEmailsInputDto;
}>;


export type UpdateSiteFormNotificationEmailsMutation = { __typename?: 'Mutation', updateSiteFormNotificationEmails: Array<{ __typename?: 'SiteFormNotificationEmailDto', email: string }> };

export type GmbLocationFragmentFragment = { __typename?: 'GmbLocationEntityDto', id: number, title: string, regionCode?: string | null, languageCode?: string | null, postalCode?: string | null, administrativeArea?: string | null, locality?: string | null, sublocality?: string | null, addressLines?: string | null, organisation?: string | null, gmbName: string, gmbAccountName?: string | null, googleAccounts: Array<{ __typename?: 'GmbLocationGoogleAccountDto', id: number, displayName: string, email?: string | null }> };

export type GmbLocationsQueryVariables = Exact<{
  paginationParam: GmbLocationPaginationParams;
}>;


export type GmbLocationsQuery = { __typename?: 'Query', gmbLocations: { __typename?: 'PaginatedGmbLocations', items: Array<{ __typename?: 'GmbLocationEntityDto', id: number, title: string, regionCode?: string | null, languageCode?: string | null, postalCode?: string | null, administrativeArea?: string | null, locality?: string | null, sublocality?: string | null, addressLines?: string | null, organisation?: string | null, gmbName: string, gmbAccountName?: string | null, googleAccounts: Array<{ __typename?: 'GmbLocationGoogleAccountDto', id: number, displayName: string, email?: string | null }> }> } };

export type GmbLocationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  gmbName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GmbLocationQuery = { __typename?: 'Query', gmbLocation: { __typename?: 'GmbLocationEntityDto', id: number, title: string, regionCode?: string | null, languageCode?: string | null, postalCode?: string | null, administrativeArea?: string | null, locality?: string | null, sublocality?: string | null, addressLines?: string | null, organisation?: string | null, gmbName: string, gmbAccountName?: string | null, googleAccounts: Array<{ __typename?: 'GmbLocationGoogleAccountDto', id: number, displayName: string, email?: string | null }> } };

export type GoogleAnalyticsAccountsQueryVariables = Exact<{
  googleAccountId: Scalars['Int']['input'];
}>;


export type GoogleAnalyticsAccountsQuery = { __typename?: 'Query', googleAnalyticsAccounts: { __typename?: 'PaginatedGoogleAnalyticsAccounts', items: Array<{ __typename?: 'GoogleAnalyticsAccountDto', accountId: string, displayName: string }> } };

export type GoogleAnalyticsAccountQueryVariables = Exact<{
  googleAccountId: Scalars['Int']['input'];
  accountId: Scalars['String']['input'];
}>;


export type GoogleAnalyticsAccountQuery = { __typename?: 'Query', googleAnalyticsAccount: { __typename?: 'GoogleAnalyticsAccountDto', accountId: string, displayName: string } };

export type GoogleAnalyticsPropertiesQueryVariables = Exact<{
  googleAccountId: Scalars['Int']['input'];
  googleAnalyticsAccountId: Scalars['String']['input'];
}>;


export type GoogleAnalyticsPropertiesQuery = { __typename?: 'Query', googleAnalyticsProperties: { __typename?: 'PaginatedGoogleAnalyticsProperties', items: Array<{ __typename?: 'GoogleAnalyticsPropertyDto', propertyId: string, displayName: string }> } };

export type GoogleAnalyticsPropertyQueryVariables = Exact<{
  googleAccountId: Scalars['Int']['input'];
  propertyId: Scalars['String']['input'];
}>;


export type GoogleAnalyticsPropertyQuery = { __typename?: 'Query', googleAnalyticsProperty: { __typename?: 'GoogleAnalyticsPropertyDto', propertyId: string, displayName: string } };

export type GoogleAccountsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GoogleAccountsQuery = { __typename?: 'Query', googleAccounts: { __typename?: 'PaginatedGoogleAccounts', items: Array<{ __typename?: 'GoogleAccountEntityDto', id: number, accountId: string, displayName: string, email?: string | null, refreshTokenStatus: RefreshTokenStatus, blocksMapped?: number | null, connectionStatus: { __typename?: 'GoogleAccountConnectionStatus', connected: boolean, error: string } }> } };

export type GoogleAccountQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GoogleAccountQuery = { __typename?: 'Query', googleAccount: { __typename?: 'GoogleAccountEntityDto', id: number, accountId: string, displayName: string } };

export type DiconnectUserGoogleAccountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DiconnectUserGoogleAccountMutation = { __typename?: 'Mutation', disconnectUserGoogleAccount: { __typename?: 'DisconnectUserGoogleAccountResult', success: boolean } };

export type ForceResyncGoogleAccountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ForceResyncGoogleAccountMutation = { __typename?: 'Mutation', syncGoogleAccount: { __typename?: 'ForceResyncGoogleAccountResult', success: boolean, message?: string | null } };

export type SyncAllGoogleAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncAllGoogleAccountsMutation = { __typename?: 'Mutation', syncAllGoogleAccounts: { __typename?: 'SyncAllGoogleAccountsResult', success: boolean, message?: string | null, accountsCount: number } };

export type UserMetaAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMetaAccountsQuery = { __typename?: 'Query', userMetaAccounts: { __typename?: 'UserMetaAccountsDto', metaAccounts: Array<{ __typename?: 'MetaAccountEntityDto', id: number, accountId: string, displayName: string, linkMethod: MetaLinkMethod, email?: string | null }> } };

export type CreateIntegrationMutationVariables = Exact<{
  Input: CreateIntegrationInputDto;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', createIntegration: { __typename?: 'IntegrationDto', id: number } };

export type UpdateIntegrationMutationVariables = Exact<{
  updateIntegration: UpdateIntegrationDto;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateIntegration: { __typename?: 'IntegrationDto', id: number } };

export type DeleteIntegrationMutationVariables = Exact<{
  deleteIntegration: IntegrationDeleteArgs;
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', deleteIntegration: { __typename?: 'IntegrationDto', id: number } };

export type CreateFormIntegrationMutationVariables = Exact<{
  formIntegration: CreateFormIntegrationInputDto;
}>;


export type CreateFormIntegrationMutation = { __typename?: 'Mutation', createFormIntegration: { __typename?: 'FormIntegrationEntityDto', id: number } };

export type UpdateFormIntegrationPagesMutationVariables = Exact<{
  formIntegrationId: Scalars['Int']['input'];
  pages: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateFormIntegrationPagesMutation = { __typename?: 'Mutation', updateFormIntegrationPages: { __typename?: 'FormIntegrationEntityDto', id: number } };

export type CreateFormIntegrationActionMutationVariables = Exact<{
  formIntegrationAction: CreateFormIntegrationActionDto;
}>;


export type CreateFormIntegrationActionMutation = { __typename?: 'Mutation', createFormIntegrationAction: { __typename?: 'FormIntegrationActionEntityDto', id: number } };

export type CopyFormIntegrationActionsToAnotherGroupMutationVariables = Exact<{
  sourceFormIntegrationId: Scalars['Int']['input'];
  targetFormIntegrationId: Scalars['Int']['input'];
}>;


export type CopyFormIntegrationActionsToAnotherGroupMutation = { __typename?: 'Mutation', copyFormIntegrationActionsToAnotherGroup: { __typename?: 'FormIntegrationEntityDto', id: number } };

export type GetOrganisationIntegrationTypesQueryVariables = Exact<{
  organisationId: Scalars['Int']['input'];
}>;


export type GetOrganisationIntegrationTypesQuery = { __typename?: 'Query', findAllOrganisationIntegrationTypes: Array<IntegrationType> };

export type DeleteFormIntegrationActionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFormIntegrationActionMutation = { __typename?: 'Mutation', deleteFormIntegrationAction: { __typename?: 'FormIntegrationActionEntityDto', id: number } };

export type UpdateFormIntegrationActionMutationVariables = Exact<{
  action: UpdateFormIntegrationActionDto;
}>;


export type UpdateFormIntegrationActionMutation = { __typename?: 'Mutation', updateFormIntegrationAction: { __typename?: 'FormIntegrationActionEntityDto', id: number } };

export type DeleteFormIntegrationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFormIntegrationMutation = { __typename?: 'Mutation', deleteFormIntegration: { __typename?: 'FormIntegrationEntityDto', id: number } };

export type IntegrationListQueryVariables = Exact<{
  type: IntegrationType;
  organisationId: Scalars['Int']['input'];
}>;


export type IntegrationListQuery = { __typename?: 'Query', integrations: { __typename?: 'PaginatedIntegration', items: Array<{ __typename?: 'IntegrationDto', id: number, name: string, type: IntegrationType, specification?: any | null }> } };

export type IntegrationListWithConnectionStatusQueryVariables = Exact<{
  type: IntegrationType;
  organisationId: Scalars['Int']['input'];
}>;


export type IntegrationListWithConnectionStatusQuery = { __typename?: 'Query', integrations: { __typename?: 'PaginatedIntegration', items: Array<{ __typename?: 'IntegrationDto', id: number, connectionStatus?: { __typename?: 'IntegrationConnectionStatus', type?: string | null, message?: string | null } | null }> } };

export type MappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MappingsQuery = { __typename?: 'Query', gmbLocationMappings: { __typename?: 'PaginatedGmbLocationMappings', items: Array<{ __typename?: 'GmbLocationMappingEntityDto', site: { __typename?: 'SiteEntityDto', name: string }, page: { __typename?: 'PageEntityDto', name: string }, field: { __typename?: 'TTSchemaFieldEntityDto', displayName: string }, gmbLocation: { __typename?: 'GmbLocationEntityDto', title: string }, googleAccount: { __typename?: 'GoogleAccountEntityDto', displayName: string, refreshTokenStatus: RefreshTokenStatus } }> } };

export type LoginQueryVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'AuthResult', success: boolean, user?: { __typename?: 'UserEntityDto', id: number, firstName: string, email: string } | null } };

export type LoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'UserEntityDto', id: number, firstName: string, email: string, preferredLocale: SupportedLocale, featureFlags: { __typename?: 'UserFeatureFlagsDto', inputValidation: { __typename?: 'InputValidationFlagOptionsDto', enabled: boolean }, formSubmissionEnqueue: { __typename?: 'FormSubmissionEnqueueFlagOptionsDto', enabled: boolean, useNewLogic: boolean } }, access: { __typename?: 'UserAccessDto', rules?: Array<any> | null }, impersonatingUser?: { __typename?: 'UserEntityDto', id: number, firstName: string, email: string } | null } | null };

export type ListUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUsers', total: number, items: Array<{ __typename?: 'UserEntityDto', id: number, firstName: string, lastName: string, email: string }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'AuthResult', user?: { __typename?: 'UserEntityDto', email: string } | null } };

export type ExitImpersonationMutationVariables = Exact<{ [key: string]: never; }>;


export type ExitImpersonationMutation = { __typename?: 'Mutation', exitImpersonate: { __typename?: 'ImpersonateResult', success: boolean } };

export type ImpersonateMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ImpersonateMutation = { __typename?: 'Mutation', impersonate: { __typename?: 'ImpersonateResult', success: boolean } };

export type GetUserQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserEntityDto', id: number, email: string, firstName: string, lastName: string } | null };

export type CreatePasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CreatePasswordResetMutation = { __typename?: 'Mutation', createPasswordReset: { __typename?: 'ResetPasswordResult', success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  user: ResetPasswordInputDto;
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPasswordWithToken: { __typename?: 'ResetPasswordResult', success: boolean } };

export type UserByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
  type: UserVerificationTokenType;
}>;


export type UserByTokenQuery = { __typename?: 'Query', userByToken: { __typename?: 'UserEntityDto', email: string } };

export type UpdateUserWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  user: UpdateUserInputDto;
}>;


export type UpdateUserWithTokenMutation = { __typename?: 'Mutation', updateUserWithToken: { __typename?: 'UserEntityDto', email: string } };

export type MetaAccountsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetaAccountsQuery = { __typename?: 'Query', metaAccounts: { __typename?: 'PaginatedMetaAccounts', items: Array<{ __typename?: 'MetaAccountEntityDto', id: number, accountId: string, displayName: string, email?: string | null, linkMethod: MetaLinkMethod, connectionStatus: { __typename?: 'MetaAccountConnectionStatus', connected: boolean, error: string } }> } };

export type MetaAccountQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MetaAccountQuery = { __typename?: 'Query', metaAccount: { __typename?: 'MetaAccountEntityDto', id: number, accountId: string, displayName: string, email?: string | null, linkMethod: MetaLinkMethod } };

export type DisconnectUserMetaAccountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DisconnectUserMetaAccountMutation = { __typename?: 'Mutation', disconnectUserMetaAccount: { __typename?: 'DisconnectUserMetaAccountResult', success: boolean } };

export type GetOrganisationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganisationsQuery = { __typename?: 'Query', organisations: { __typename?: 'PaginatedOrganisations', total: number, items: Array<{ __typename?: 'OrganisationEntityDto', id: number, name: string, brandsCount?: number | null }> } };

export type CreateOrganisationMutationVariables = Exact<{
  organisation: CreateOrganisationDto;
}>;


export type CreateOrganisationMutation = { __typename?: 'Mutation', createOrganisation: { __typename?: 'OrganisationEntityDto', id: number, name: string } };

export type UpdateOrganisationMutationVariables = Exact<{
  organisation: UpdateOrganisationDto;
}>;


export type UpdateOrganisationMutation = { __typename?: 'Mutation', updateOrganisation: { __typename?: 'OrganisationEntityDto', id: number, name: string } };

export type DeleteOrganisationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOrganisationMutation = { __typename?: 'Mutation', deleteOrganisation: { __typename?: 'OrganisationEntityDto', id: number } };

export type GetOrganisationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrganisationQuery = { __typename?: 'Query', organisation: { __typename?: 'OrganisationEntityDto', id: number, name: string } };

export type GetOrganisationUsersQueryVariables = Exact<{
  paginationParams: OrganisationUsersPaginationParams;
}>;


export type GetOrganisationUsersQuery = { __typename?: 'Query', organisationUsers: { __typename?: 'PaginatedUsers', total: number, items: Array<{ __typename?: 'UserEntityDto', id: number, firstName: string, lastName: string, email: string, verified: boolean }> } };

export type SubschemaFragmentFragment = { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> };

export type RevisionSchemaFragmentFragment = { __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null };

export type RevisionFragmentFragment = { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> };

export type TtschemaFragmentFragment = { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, visibility: TtSchemaVisibility, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, helpText?: string | null, description?: string | null, displayName: string, hasMultipleValues: boolean, type: TtSchemaFieldType, sortOrder: number, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> };

export type PageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, urlPath?: string | null, metaTitle?: string | null, metaDescription?: string | null, allowCrawling?: boolean | null, templateId?: number | null, scheduledAt?: any | null, site: { __typename?: 'SiteEntityDto', id: number, customScriptHead: string, customScriptBody: string, primaryDomain?: { __typename?: 'PrimaryDomainDto', id: number, domainName: string, ssl: boolean, path?: string | null } | null, brand: { __typename?: 'BrandEntityDto', organisation: { __typename?: 'OrganisationEntityDto', id: number } }, config?: { __typename?: 'SiteConfigDto', version?: string | null } | null }, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, draftCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number } | null, publishedCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number } | null, parent?: { __typename?: 'PageEntityDto', id: number } | null, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null } };

export type PageForPublishValidationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageForPublishValidationQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, template?: { __typename?: 'TemplateEntityDto', id: number } | null, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null, site: { __typename?: 'SiteEntityDto', id: number }, parent?: { __typename?: 'PageEntityDto', id: number } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null, draftCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } };

export type AllSitePageIdsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  pageName?: InputMaybe<Scalars['String']['input']>;
  schemaTypeId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  requirePageTypeId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllSitePageIdsQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', total: number, items: Array<{ __typename?: 'PageEntityDto', id: number }> } };

export type SitePagesQueryVariables = Exact<{
  pageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<PageOrder>;
  orderDirection?: InputMaybe<PageOrderDirection>;
  schemaTypeId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  requirePageTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
}>;


export type SitePagesQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', total: number, items: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, metaTitle?: string | null, metaDescription?: string | null, allowCrawling?: boolean | null, templateId?: number | null, urlPath?: string | null, scheduledAt?: any | null, childrenCount: number, pageType?: { __typename?: 'TTSchemaEntityDto', name: string, titleSingular: string } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any } | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, draftCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number } | null, publishedCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number } | null, parent?: { __typename?: 'PageEntityDto', id: number } | null, campaignParent?: { __typename?: 'PageEntityDto', id: number } | null }> } };

export type PageSelectorSitePagesQueryVariables = Exact<{
  pageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PageSelectorSitePagesQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', total: number, items: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, pageType?: { __typename?: 'TTSchemaEntityDto', titleSingular: string } | null }> } };

export type List_PagesQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type List_PagesQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', items: Array<{ __typename?: 'PageEntityDto', id: number, name: string, childrenCount: number }> } };

export type ParentPageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ParentPageQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, urlPath?: string | null, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titleSingular: string } | null, parent?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, parent?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null } | null } | null } };

export type PaginatedPageQueryQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  excludeRecursive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PaginatedPageQueryQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', items: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, urlSegment: string }> } };

export type ValidatePageCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidatePageCreateQuery = { __typename?: 'Query', validateCreatePageDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type CreatePageMutationVariables = Exact<{
  page: CreatePageDto;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'PageEntityDto', id: number } };

export type PageOptionsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageOptionsQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', items: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, urlSegment: string }> } };

export type GetPageWithPageTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPageWithPageTypeQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string } | null } };

export type PublishPageMutationVariables = Exact<{
  pageId: Scalars['Int']['input'];
}>;


export type PublishPageMutation = { __typename?: 'Mutation', publishPage: { __typename?: 'PublishPageResult', success: boolean } };

export type UnpublishPageMutationVariables = Exact<{
  pageId: Scalars['Int']['input'];
}>;


export type UnpublishPageMutation = { __typename?: 'Mutation', unpublishPage: { __typename?: 'UnpublishPageResult', success: boolean } };

export type UpdatePageMutationVariables = Exact<{
  page: UpdatePageDto;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'PageEntityDto', id: number } };

export type UpdatePageSeoSettingsMutationVariables = Exact<{
  page: UpdatePageSeoSettingsDto;
}>;


export type UpdatePageSeoSettingsMutation = { __typename?: 'Mutation', updatePageSEOSettings: { __typename?: 'PageEntityDto', id: number } };

export type PageCustomFieldsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageCustomFieldsQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null, templateId?: number | null, scheduledAt?: any | null, template?: { __typename?: 'TemplateEntityDto', publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null } | null, publishedCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null, draftCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, parent?: { __typename?: 'PageEntityDto', id: number } | null, site: { __typename?: 'SiteEntityDto', id: number, customScriptHead: string, customScriptBody: string, primaryDomain?: { __typename?: 'PrimaryDomainDto', id: number, domainName: string, ssl: boolean, path?: string | null } | null }, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null } };

export type PageCustomFieldsPreviewQueryVariables = Exact<{
  pageData: PageRevisionReferencesWithRevisionSchemas;
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageCustomFieldsPreviewQuery = { __typename?: 'Query', pageRevisionFromPageData: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } };

export type DiscardPageDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DiscardPageDraftMutation = { __typename?: 'Mutation', discardPageDraft?: { __typename?: 'PageEntityDto', id: number, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null };

export type DiscardTemplateDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DiscardTemplateDraftMutation = { __typename?: 'Mutation', discardTemplateDraft?: { __typename?: 'TemplateEntityDto', id: number, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null };

export type PageForSettingsQueryVariables = Exact<{
  pageId: Scalars['Int']['input'];
}>;


export type PageForSettingsQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, urlPath?: string | null, allowCrawling?: boolean | null, excludeFromSitemap?: boolean | null, metaTitle?: string | null, metaDescription?: string | null, metaTags?: string | null, templateId?: number | null, parent?: { __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null } | null, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string } | null } };

export type ValidatePageUpdateSettingsQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidatePageUpdateSettingsQuery = { __typename?: 'Query', validateUpdatePageDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type GetPageParentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPageParentQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, parent?: { __typename?: 'PageEntityDto', id: number } | null } };

export type DeletePageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage: { __typename?: 'PageEntityDto', id: number } };

export type CancelScheduledPublishMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CancelScheduledPublishMutation = { __typename?: 'Mutation', cancelScheduledPublish: { __typename?: 'PageEntityDto', id: number } };

export type DuplicatePageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DuplicatePageMutation = { __typename?: 'Mutation', duplicatePage: { __typename?: 'PageEntityDto', id: number } };

export type CheckPageUsagesInCampaignsQueryVariables = Exact<{
  pageId: Scalars['Int']['input'];
}>;


export type CheckPageUsagesInCampaignsQuery = { __typename?: 'Query', checkPageUsagesInCampaigns?: Array<{ __typename?: 'CampaignEntityDto', id: number, name: string }> | null };

export type ResolveReferencesQueryVariables = Exact<{
  pageId?: InputMaybe<Scalars['Int']['input']>;
  references: Array<UnresolvedReferenceDto> | UnresolvedReferenceDto;
}>;


export type ResolveReferencesQuery = { __typename?: 'Query', resolveReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }> };

export type GetPageTypesQueryVariables = Exact<{
  pageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetPageTypesQuery = { __typename?: 'Query', getPageTypes: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titleSingular: string }> };

export type GetPageTemplatesQueryVariables = Exact<{
  pageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetPageTemplatesQuery = { __typename?: 'Query', getPageTemplates: Array<{ __typename?: 'TemplateEntityDto', id: number, name: string, type: TemplateType }> };

export type ClonePagesMutationVariables = Exact<{
  clonePagesInput: ClonePagesInput;
}>;


export type ClonePagesMutation = { __typename?: 'Mutation', clonePages: { __typename?: 'PageCloneResult', success: boolean } };

export type ImportPagesFromJsonMutationVariables = Exact<{
  importInput: ImportPagesFromJsonInput;
}>;


export type ImportPagesFromJsonMutation = { __typename?: 'Mutation', importPagesFromJson: { __typename?: 'ImportPagesFromJsonResult', success: boolean, errorMessage?: string | null, pagesCreated: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlPath?: string | null }> } };

export type GetPageOwnershipQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPageOwnershipQuery = { __typename?: 'Query', page: { __typename?: 'PageEntityDto', id: number, site: { __typename?: 'SiteEntityDto', id: number }, parent?: { __typename?: 'PageEntityDto', id: number } | null } };

export type RedirectsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type RedirectsQuery = { __typename?: 'Query', redirects: { __typename?: 'PaginatedRedirects', total: number, items: Array<{ __typename?: 'RedirectEntityDto', id: number, fromPath: string, toUrl?: string | null, toType: RedirectToType, type: RedirectType, status: RedirectStatus, redirectHitCount: number, redirectDomain?: string | null, toPage?: { __typename?: 'ToPageEntityDto', id: number, name: string, urlSegment?: string | null, urlPath?: string | null } | null }> } };

export type CreateRedirectMutationVariables = Exact<{
  createRedirectInput: CreateRedirectEntityDto;
}>;


export type CreateRedirectMutation = { __typename?: 'Mutation', createRedirect: { __typename?: 'RedirectEntityDto', id: number } };

export type UpdateRedirectMutationVariables = Exact<{
  updateRedirectInput: UpdateRedirectEntityDto;
}>;


export type UpdateRedirectMutation = { __typename?: 'Mutation', updateRedirect: { __typename?: 'RedirectEntityDto', id: number } };

export type DeleteRedirectMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteRedirectMutation = { __typename?: 'Mutation', deleteRedirect: { __typename?: 'RedirectEntityDto', id: number } };

export type PreviewImportRedirectsMutationVariables = Exact<{
  siteId: Scalars['Int']['input'];
  items: Array<ImportRedirectItem> | ImportRedirectItem;
}>;


export type PreviewImportRedirectsMutation = { __typename?: 'Mutation', previewImportRedirects: { __typename?: 'ImportRedirectsPreview', validCount: number, pageCount: number, urlCount: number, invalidCount: number, rows: Array<{ __typename?: 'ImportRedirectResolution', row: number, source: string, destination: string, type: RedirectType, status: RedirectStatus, outcome: ImportRedirectOutcome, toUrl?: string | null, pageId?: number | null, pageUrlPath?: string | null, message?: string | null }> } };

export type ImportRedirectsMutationVariables = Exact<{
  siteId: Scalars['Int']['input'];
  items: Array<ImportRedirectItem> | ImportRedirectItem;
}>;


export type ImportRedirectsMutation = { __typename?: 'Mutation', importRedirects: { __typename?: 'ImportRedirectsResult', success: boolean, createdCount: number, skippedCount: number, rows: Array<{ __typename?: 'ImportRedirectResolution', row: number, outcome: ImportRedirectOutcome, message?: string | null }> } };

export type SiteReportDataQueryVariables = Exact<{
  report: SiteReportRequestDto;
}>;


export type SiteReportDataQuery = { __typename?: 'Query', generateSiteReport: { __typename?: 'ReportResultDto', stats: Array<{ __typename?: 'ReportStatDto', type: ReportStatType, data: any }> } };

export type GetSchemaFieldsQueryVariables = Exact<{
  ttSchemaId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<TtEntityLifecycleStatus>;
}>;


export type GetSchemaFieldsQuery = { __typename?: 'Query', ttSchemaFields: { __typename?: 'PaginatedTTSchemaFields', total: number, items: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, displayName: string, sortOrder: number, description?: string | null, readOnly: boolean, hasMultipleValues: boolean, helpText?: string | null, visibility: TtSchemaFieldVisibility, required: boolean, typeDefinition?: any | null, deletedAt?: string | null, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number, name: string, ttschemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number } }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titleSingular: string } | null }> } };

export type GetSchemaFieldQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSchemaFieldQuery = { __typename?: 'Query', ttSchemaField: { __typename?: 'TTSchemaFieldEntityDto', id: number, name: string } };

export type CreateSchemaFieldMutationVariables = Exact<{
  createTTSchemaFieldDto: CreateTtSchemaFieldDto;
}>;


export type CreateSchemaFieldMutation = { __typename?: 'Mutation', createTTSchemaField: { __typename?: 'TTSchemaFieldEntityDto', id: number } };

export type UpdateSchemaFieldMutationVariables = Exact<{
  updateTTSchemaFieldDto: UpdateTtSchemaFieldDto;
}>;


export type UpdateSchemaFieldMutation = { __typename?: 'Mutation', updateTTSchemaField: { __typename?: 'TTSchemaFieldEntityDto', id: number } };

export type DeleteSchemaFieldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSchemaFieldMutation = { __typename?: 'Mutation', deleteTTSchemaField: { __typename?: 'TTSchemaFieldDeleteResult', success: boolean } };

export type RestoreSchemaFieldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RestoreSchemaFieldMutation = { __typename?: 'Mutation', restoreDeletedTTSchemaField: { __typename?: 'TTSchemaFieldEntityDto', id: number } };

export type ValidateSchemaFieldCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaFieldCreateQuery = { __typename?: 'Query', validateTTSchemaFieldCreateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type ValidateSchemaFieldUpdateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaFieldUpdateQuery = { __typename?: 'Query', validateTTSchemaFieldUpdateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type GetSchemaSetsQueryVariables = Exact<{
  organisationId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSchemaSetsQuery = { __typename?: 'Query', ttSchemaWrappers: { __typename?: 'PaginatedTTSchemaWrappers', total: number, items: Array<{ __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string, deletable: boolean }> } };

export type GetSchemaSetQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSchemaSetQuery = { __typename?: 'Query', ttSchemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string, deletable: boolean, organisation: { __typename?: 'OrganisationEntityDto', id: number } } };

export type CreateSchemaSetMutationVariables = Exact<{
  createTTSchemaWrapperInput: TtSchemaWrapperInput;
}>;


export type CreateSchemaSetMutation = { __typename?: 'Mutation', createTTSchemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number } };

export type UpdateSchemaSetMutationVariables = Exact<{
  updateTTSchemaWrapperInput: UpdateTtSchemaWrapperInput;
}>;


export type UpdateSchemaSetMutation = { __typename?: 'Mutation', updateTTSchemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number } };

export type DeleteSchemaSetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSchemaSetMutation = { __typename?: 'Mutation', deleteTTSchemaWrapper: { __typename?: 'TTSchemaWrapperDeleteResult', success: boolean } };

export type CloneSchemaSetMutationVariables = Exact<{
  wrapperId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type CloneSchemaSetMutation = { __typename?: 'Mutation', cloneTTSchemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string } };

export type ValidateSchemaSetCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaSetCreateQuery = { __typename?: 'Query', validateTTSchemaWrapperCreateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type ValidateSchemaSetUpdateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaSetUpdateQuery = { __typename?: 'Query', validateTTSchemaWrapperUpdateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type ValidateSchemaSetCloneQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaSetCloneQuery = { __typename?: 'Query', validateTTSchemaWrapperCloneDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type GetSchemasQueryVariables = Exact<{
  ttSchemaWrapperId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TtSchemaType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  visibilities?: InputMaybe<Array<TtSchemaVisibility> | TtSchemaVisibility>;
  lifecycleStatus?: InputMaybe<TtEntityLifecycleStatus>;
}>;


export type GetSchemasQuery = { __typename?: 'Query', ttSchemas: { __typename?: 'PaginatedTTSchemas', total: number, items: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titleSingular: string, titlePlural: string, type: TtSchemaType, visibility: TtSchemaVisibility, deletedAt?: string | null }> } };

export type GetSchemaQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  includedDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSchemaQuery = { __typename?: 'Query', TTSchema: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titleSingular: string, type: TtSchemaType, ttschemaWrapper: { __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string } } };

export type GetTtSchemaWithSubschemaQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTtSchemaWithSubschemaQuery = { __typename?: 'Query', TTSchema: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, visibility: TtSchemaVisibility, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, helpText?: string | null, description?: string | null, displayName: string, hasMultipleValues: boolean, type: TtSchemaFieldType, sortOrder: number, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } };

export type CreateSchemaMutationVariables = Exact<{
  createTTSchemaInput: CreateTtSchemaInput;
}>;


export type CreateSchemaMutation = { __typename?: 'Mutation', createTTSchema: { __typename?: 'TTSchemaEntityDto', id: number } };

export type UpdateSchemaMutationVariables = Exact<{
  updateTTSchemaInput: UpdateTtSchemaInput;
}>;


export type UpdateSchemaMutation = { __typename?: 'Mutation', updateTTSchema: { __typename?: 'TTSchemaEntityDto', id: number } };

export type UpdateSchemaFieldSortOrderMutationVariables = Exact<{
  updateTTSchemaFieldSortOrderInput: TtSchemaFieldSortOrderInput;
}>;


export type UpdateSchemaFieldSortOrderMutation = { __typename?: 'Mutation', updateTTSchemaFieldOrder: { __typename?: 'TTSchemaFieldSortOrderUpdateResult', success: boolean } };

export type DeleteSchemaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSchemaMutation = { __typename?: 'Mutation', deleteTTSchema: { __typename?: 'TTSchemaDeleteResult', success: boolean } };

export type RestoreSchemaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RestoreSchemaMutation = { __typename?: 'Mutation', restoreDeletedTTSchema: { __typename?: 'TTSchemaEntityDto', id: number } };

export type ValidateSchemaCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaCreateQuery = { __typename?: 'Query', validateTTSchemaCreateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type ValidateSchemaUpdateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSchemaUpdateQuery = { __typename?: 'Query', validateTTSchemaUpdateDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type CreateSchemaBlockMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSchemaBlockMutation = { __typename?: 'Mutation', createSchemaBlock: { __typename?: 'SchemaBlockEntityDto', id: number } };

export type GenerateSchemaBlockThumbnailMutationVariables = Exact<{
  blockId: Scalars['Int']['input'];
}>;


export type GenerateSchemaBlockThumbnailMutation = { __typename?: 'Mutation', generateSchemaBlockThumbnail: { __typename?: 'GenerateSchemaBlockThumbnailResult', success: boolean } };

export type GenerateSiteThumbnailMutationVariables = Exact<{
  siteId: Scalars['Int']['input'];
}>;


export type GenerateSiteThumbnailMutation = { __typename?: 'Mutation', generateSiteThumbnail: { __typename?: 'GenerateSiteThumbnailResult', success: boolean } };

export type GetPageTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPageTypeQuery = { __typename?: 'Query', TTSchema: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string } };

export type GetTtSchemaUsagesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  ttSchemaWrapperId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTtSchemaUsagesQuery = { __typename?: 'Query', checkTTSchemaUsages: { __typename?: 'PaginatedTTSchemaUsages', total: number, items: Array<{ __typename?: 'TTSchemaUsagesResult', pages: Array<{ __typename?: 'PageEntityDto', id: number, name: string, urlSegment: string, parent?: { __typename?: 'PageEntityDto', name: string, urlPath?: string | null } | null, site: { __typename?: 'SiteEntityDto', id: number, name: string }, draftCustomFields?: { __typename?: 'PageRevisionEntityDto', id: number } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null }>, templates: Array<{ __typename?: 'TemplateEntityDto', id: number, name: string, site: { __typename?: 'SiteEntityDto', id: number, name: string } }>, schemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, titleSingular: string, type: TtSchemaType }> }> } };

export type OrganisationSitesQueryVariables = Exact<{
  organisationId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganisationSitesQuery = { __typename?: 'Query', organisation: { __typename?: 'OrganisationEntityDto', sites: { __typename?: 'PaginatedSites', total: number, items: Array<{ __typename?: 'SiteEntityDto', id: number, name: string, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, primaryDomain?: { __typename?: 'PrimaryDomainDto', ssl: boolean, domainName: string } | null }> } } };

export type GetSitesQueryVariables = Exact<{
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireAnalyticsConfig?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSitesQuery = { __typename?: 'Query', sites: { __typename?: 'PaginatedSites', total: number, items: Array<{ __typename?: 'SiteEntityDto', id: number, name: string, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, primaryDomain?: { __typename?: 'PrimaryDomainDto', ssl: boolean, domainName: string } | null }> } };

export type GetSiteQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSiteQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', id: number, name: string, customScriptHead: string, customScriptBody: string, timezone?: string | null, webhooks: Array<string>, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, ttSchemaWrapper?: { __typename?: 'TTSchemaWrapperEntityDto', id: number } | null, brand: { __typename?: 'BrandEntityDto', id: number, organisation: { __typename?: 'OrganisationEntityDto', id: number } }, homepage?: { __typename?: 'PageEntityDto', id: number } | null, headerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, footerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, error404Template?: { __typename?: 'TemplateEntityDto', id: number } | null, error500Template?: { __typename?: 'TemplateEntityDto', id: number } | null, primaryDomain?: { __typename?: 'PrimaryDomainDto', id: number, domainName: string, ssl: boolean, path?: string | null } | null, siteDomainsWithPath: Array<{ __typename?: 'SiteDomainConfigDto', id: number, domainName: string, path: string, ssl: boolean, verification: boolean }>, config?: { __typename?: 'SiteConfigDto', integrations?: { __typename?: 'SiteIntegrationConfigDto', glofox?: { __typename?: 'SiteIntegrationGlofoxConfigDto', reporting?: { __typename?: 'SiteIntegrationGlofixReportingConfigDto', apiUrl?: string | null } | null } | null } | null, googleAnalytics?: { __typename?: 'SiteGoogleAnalyticsConfig', googleAccountId?: number | null, accountId?: string | null, propertyId?: string | null } | null } | null } };

export type SiteWithConfigQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SiteWithConfigQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', id: number, name: string, customScriptHead: string, customScriptBody: string, webhooks: Array<string>, brand: { __typename?: 'BrandEntityDto', id: number, organisation: { __typename?: 'OrganisationEntityDto', id: number } }, ttSchemaWrapper?: { __typename?: 'TTSchemaWrapperEntityDto', id: number } | null, primaryDomain?: { __typename?: 'PrimaryDomainDto', domainName: string, ssl: boolean, path?: string | null } | null, config?: { __typename?: 'SiteConfigDto', integrations?: { __typename?: 'SiteIntegrationConfigDto', glofox?: { __typename?: 'SiteIntegrationGlofoxConfigDto', reporting?: { __typename?: 'SiteIntegrationGlofixReportingConfigDto', apiUrl?: string | null } | null } | null } | null } | null } };

export type CreateSiteMutationVariables = Exact<{
  createSiteDto: CreateSiteDto;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'SiteEntityDto', id: number } };

export type UpdateSiteMutationVariables = Exact<{
  updateSiteDto: UpdateSiteDto;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite: { __typename?: 'SiteEntityDto', id: number } };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: { __typename?: 'SiteEntityDto', id: number } };

export type CloneSiteMutationVariables = Exact<{
  input: CloneSiteInputDto;
}>;


export type CloneSiteMutation = { __typename?: 'Mutation', cloneSite: { __typename?: 'CloneSiteResultDto', targetSiteId: number, targetSiteName: string, pagesCloned: number, templatesCloned: number, formsCloned: number } };

export type ValidateSiteCreateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSiteCreateQuery = { __typename?: 'Query', validateCreateSiteDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type ValidateSiteUpdateQueryVariables = Exact<{
  input: ValidationInputDto;
}>;


export type ValidateSiteUpdateQuery = { __typename?: 'Query', validateUpdateSiteDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type SiteWithTtSchemaWrapperQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  type?: InputMaybe<TtSchemaType>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SiteWithTtSchemaWrapperQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', id: number, name: string, headerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, footerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, primaryDomain?: { __typename?: 'PrimaryDomainDto', domainName: string, ssl: boolean, path?: string | null } | null, ttSchemaWrapper?: { __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string, ttschemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, visibility: TtSchemaVisibility, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, helpText?: string | null, description?: string | null, displayName: string, hasMultipleValues: boolean, type: TtSchemaFieldType, sortOrder: number, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> }> } | null } };

export type SiteTemplatesWithRevisionQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  type?: InputMaybe<TemplateType>;
  query?: InputMaybe<Scalars['String']['input']>;
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteTemplatesWithRevisionQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', headerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, footerTemplate?: { __typename?: 'TemplateEntityDto', id: number } | null, templates: Array<{ __typename?: 'TemplateEntityDto', id: number, name: string, type: TemplateType, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null }> } };

export type SiteIntegrationsQueryVariables = Exact<{
  type: IntegrationType;
  organisationId: Scalars['Int']['input'];
}>;


export type SiteIntegrationsQuery = { __typename?: 'Query', integrations: { __typename?: 'PaginatedIntegration', items: Array<{ __typename?: 'IntegrationDto', id: number, name: string, type: IntegrationType }> } };

export type GetSitePageTypesQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  type?: InputMaybe<TtSchemaType>;
}>;


export type GetSitePageTypesQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', id: number, name: string, ttSchemaWrapper?: { __typename?: 'TTSchemaWrapperEntityDto', id: number, name: string, ttschemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string }> } | null } };

export type SiteGlofoxFormsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  form: GlofoxForm;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SiteGlofoxFormsQuery = { __typename?: 'Query', site: { __typename?: 'SiteEntityDto', glofoxFormSubmissions: { __typename?: 'PaginatedGlofoxFormLeads', total: number, items: Array<{ __typename?: 'GlofoxFormSubmission', id: number, step: string, glofoxBranchId: string, glofoxUserId: string, email: string, agreementsStatus: string, createdAt: string, page?: { __typename?: 'GlofoxFormSubmissionPageDto', name: string, urlPath: string } | null }> } } };

export type ValidateSiteNameQueryVariables = Exact<{
  siteName: Scalars['String']['input'];
  organisationId: Scalars['Int']['input'];
}>;


export type ValidateSiteNameQuery = { __typename?: 'Query', validateSiteName: { __typename?: 'SiteNameValidationDto', isValid: boolean, message?: string | null } };

export type TemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  draftMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TemplateQuery = { __typename?: 'Query', template: { __typename?: 'TemplateEntityDto', id: number, name: string, type: TemplateType, scheduledAt?: any | null, pageType?: { __typename?: 'TTSchemaEntityDto', id: number, titleSingular: string } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, references?: any | null, type: PageRevisionType, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, template?: { __typename?: 'TemplateEntityDto', id: number, name: string, deletedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any, resolvedReferences: Array<{ __typename?: 'ResolvedReferenceDto', dynamicReference: string, value?: any | null }>, schema: Array<{ __typename?: 'PageRevisionSchemaEntityDto', id: number, sortOrder: number, anchorId?: string | null, label?: string | null, campaign: boolean, schemaBlockId?: number | null, hideBlockForCampaignPlaceholders?: Array<number> | null, inHeader?: boolean | null, inFooter?: boolean | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null } | null, properties?: Array<{ __typename?: 'PageRevisionSchemaProperties', fieldId: number, name: string, value: any, isDynamic: boolean, dynamicReference?: string | null, valueReferences?: Array<{ __typename?: 'PageRevisionSchemaPropertyValueReference', referenceId: string }> | null }> | null, ttschema?: { __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, deletedAt?: string | null, thumbnailImageUrls?: { __typename?: 'DeviceScreenshotDto', desktop?: string | null, tablet?: string | null, mobile?: string | null } | null, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, displayName: string, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }>, subSchemas: Array<{ __typename?: 'TTSchemaEntityDto', id: number, name: string, titlePlural: string, titleSingular: string, type: TtSchemaType, fields: Array<{ __typename?: 'TTSchemaFieldEntityDto', id: number, name: string, displayName: string, type: TtSchemaFieldType, readOnly: boolean, hasMultipleValues: boolean, typeDefinition?: any | null, visibility: TtSchemaFieldVisibility, sortOrder: number, required: boolean, TTSchema: { __typename?: 'TTSchemaEntityDto', id: number }, typeTTSchema?: { __typename?: 'TTSchemaEntityDto', id: number } | null }> }> } | null }> } | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any } | null, site: { __typename?: 'SiteEntityDto', id: number } } };

export type ValidateTemplateFixedUpdateQueryVariables = Exact<{
  object: Scalars['JSON']['input'];
}>;


export type ValidateTemplateFixedUpdateQuery = { __typename?: 'Query', validateUpdateTemplateInputDto: { __typename?: 'ValidationResultDto', hasErrors: boolean, errors: Array<{ __typename?: 'WrappedValidationError', property: string, constraints: any }> } };

export type UpdateTemplateMutationVariables = Exact<{
  updateTemplateDto: UpdateTemplateInputDto;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'TemplateEntityDto', id: number } };

export type SiteTemplatesQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  type?: InputMaybe<TemplateType>;
  types?: InputMaybe<Array<TemplateType> | TemplateType>;
  query?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<TemplateOrder>;
  orderDirection?: InputMaybe<TemplateOrderDirection>;
}>;


export type SiteTemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'PaginatedTemplates', total: number, items: Array<{ __typename?: 'TemplateEntityDto', id: number, name: string, type: TemplateType, campaign?: boolean | null, scheduledAt?: any | null, updatedAt?: string | null, publishedRevision?: { __typename?: 'PageRevisionEntityDto', id: number } | null, draftRevision?: { __typename?: 'PageRevisionEntityDto', id: number, createdAt: any } | null }> } };

export type CreateTemplateMutationVariables = Exact<{
  createTemplateInput: CreateTemplateInput;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'TemplateEntityDto', id: number } };

export type CloneTemplateMutationVariables = Exact<{
  cloneTemplateInput: CloneTemplateInput;
}>;


export type CloneTemplateMutation = { __typename?: 'Mutation', cloneTemplate: { __typename?: 'TemplateEntityDto', id: number } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'TemplateEntityDto', id: number } };

export type TemplatePagesQueryVariables = Exact<{
  templateId: Scalars['Int']['input'];
  siteId: Scalars['Int']['input'];
}>;


export type TemplatePagesQuery = { __typename?: 'Query', pages: { __typename?: 'PaginatedPages', items: Array<{ __typename?: 'PageEntityDto', id: number, name: string }> } };

export type CancelScheduledTemplatePublishMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CancelScheduledTemplatePublishMutation = { __typename?: 'Mutation', cancelScheduledTemplatePublish: { __typename?: 'TemplateEntityDto', id: number } };

export type GetListOfUsagesForSwbTemplatesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListOfUsagesForSwbTemplatesQuery = { __typename?: 'Query', getListOfUsagesForSWBTemplates: { __typename?: 'UsagesOfSWBDTO', pages: Array<string>, templates: Array<string> } };

export type GetListOfUsagesForCampaignTemplatesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListOfUsagesForCampaignTemplatesQuery = { __typename?: 'Query', getListOfUsagesForCampaignTemplates: { __typename?: 'UsagesOfCampaignTemplateDTO', campaigns: Array<{ __typename?: 'CampaignTemplateUsageDTO', id: number, name: string, status: string }> } };

export type GetListOfUsagesForPageTemplatesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetListOfUsagesForPageTemplatesQuery = { __typename?: 'Query', getListOfUsagesForPageTemplates: { __typename?: 'UsagesOfPageTemplateDTO', pages: Array<{ __typename?: 'PageTemplateUsageDTO', id: number, name: string }> } };

export type DeleteTemplateAndPagesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTemplateAndPagesMutation = { __typename?: 'Mutation', deleteTemplateAndPages: { __typename?: 'TemplateEntityDto', id: number } };

export type DetachPagesAndDeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DetachPagesAndDeleteTemplateMutation = { __typename?: 'Mutation', detachPagesAndDeleteTemplate: { __typename?: 'TemplateEntityDto', id: number } };

export type GetUserApiTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserApiTokensQuery = { __typename?: 'Query', userApiTokens: Array<{ __typename?: 'UserApiTokenDto', id: number, name?: string | null, createdAt: any, expiresAt?: any | null, lastAccessAt?: any | null }> };

export type CreateUserApiTokenMutationVariables = Exact<{
  expirySecs?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserApiTokenMutation = { __typename?: 'Mutation', createUserApiToken: { __typename?: 'CreateUserApiTokenResult', apiKey: string, name?: string | null, expiresAt?: any | null } };

export type DeleteUserApiTokenMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteUserApiTokenMutation = { __typename?: 'Mutation', deleteUserApiToken: { __typename?: 'DeleteUserApiTokenResult', success: boolean } };

export type GrantUserResourceByEmailMutationVariables = Exact<{
  resourceId: Scalars['Int']['input'];
  resourceIdentifier: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type GrantUserResourceByEmailMutation = { __typename?: 'Mutation', grantUserResourceByEmail: { __typename?: 'UserResourceEntityDto', id: number } };

export type GetOrganisationUserResourcesQueryVariables = Exact<{
  paginationParams: OrganisationUserResourcesPaginationParams;
}>;


export type GetOrganisationUserResourcesQuery = { __typename?: 'Query', organisationUserResources: { __typename?: 'PaginatedUserResources', total: number, items: Array<{ __typename?: 'UserResourceEntityDto', id: number, resourceId: number, resourceIdentifier: string, resourceName: string, role: { __typename?: 'RoleEntityDto', id: number, name: string } }> } };

export type DeleteUserResourceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteUserResourceMutation = { __typename?: 'Mutation', deleteUserResource: { __typename?: 'UserResourceEntityDto', id: number } };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: { __typename?: 'PaginatedRoles', items: Array<{ __typename?: 'RoleEntityDto', id: number, name: string, priority: number }> } };

export type GetUserRolesQueryVariables = Exact<{
  resourceId: Scalars['Int']['input'];
  resourceIdentifier: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserRolesQuery = { __typename?: 'Query', resourceUsers: { __typename?: 'PaginatedUsersWithRoles', total: number, items: Array<{ __typename?: 'UserWithRoles', id: number, firstName: string, lastName: string, email: string, primaryRole?: { __typename?: 'UserRoleDto', id: number, name: string, explicit: boolean, from: { __typename?: 'UserResourceEntityDto', id: number, resourceId: number, resourceIdentifier: string, role: { __typename?: 'RoleEntityDto', id: number } } } | null, explicitRole?: { __typename?: 'UserRoleDto', id: number, name: string, from: { __typename?: 'UserResourceEntityDto', id: number } } | null }> } };

export type RevokeAllUserResourcesForOrganisationMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
}>;


export type RevokeAllUserResourcesForOrganisationMutation = { __typename?: 'Mutation', revokeAllUserResourcesForOrganisation: { __typename?: 'RevokeAllUserResourcesOnOrganisationResult', success: boolean } };

export type UpdatePreferredLocaleMutationVariables = Exact<{
  locale: SupportedLocale;
}>;


export type UpdatePreferredLocaleMutation = { __typename?: 'Mutation', updatePreferredLocale: { __typename?: 'UserEntityDto', id: number, preferredLocale: SupportedLocale } };

export type CreatePageRevisionMutationVariables = Exact<{
  createPageRevision: CreatePageRevisionInput;
}>;


export type CreatePageRevisionMutation = { __typename?: 'Mutation', createPageRevision: { __typename?: 'PageRevisionEntityDto', id: number } };

import { IntrospectionQuery } from 'graphql';

export default {
  "__schema": {
    "queryType": {
      "name": "Query"
    },
    "mutationType": {
      "name": "Mutation"
    },
    "subscriptionType": null,
    "types": [
      {
        "kind": "OBJECT",
        "name": "AltTextPendingImage",
        "fields": [
          {
            "name": "currentAltText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fileName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "imageUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "revisionSchemaId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssetEntityDto",
        "fields": [
          {
            "name": "accessLevel",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "altText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fileName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "height",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isAssociated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mimeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sizeInBytes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "width",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssetUploadResponseDto",
        "fields": [
          {
            "name": "accessLevel",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "altText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fileName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "height",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isAssociated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mimeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "signedURL",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sizeInBytes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "width",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditLogEntityDto",
        "fields": [
          {
            "name": "action",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "detail",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "detailObj",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "impersonatingUser",
            "type": {
              "kind": "OBJECT",
              "name": "AuditLogUserDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "OBJECT",
              "name": "AuditLogPageDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "resourceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resourceType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "AuditLogUserDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditLogPageDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "siteId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuditLogUserDto",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuthResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "UserEntityDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BrandEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "organisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sites",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Breadcrumb",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "urlPath",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BulkUpdateAltTextResult",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updatedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignAnnouncementResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignDeleteResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignEntityDto",
        "fields": [
          {
            "name": "campaignPageMetadata",
            "type": {
              "kind": "OBJECT",
              "name": "CampaignPageMetadataDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "consentType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "endTime",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "imageUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageType",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "placeholderTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CampaignPlaceholderTemplateDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "startTime",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignForceEndResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignForceStartResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPageEntityDto",
        "fields": [
          {
            "name": "editable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "optedIn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "subpage",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPageMetadataDto",
        "fields": [
          {
            "name": "allowCrawling",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metaDescription",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metaTitle",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "template",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "urlSegment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPageOptInStatusUpdateResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPageUsageResult",
        "fields": [
          {
            "name": "usages",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CampaignEntityDto",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPlaceholderDto",
        "fields": [
          {
            "name": "campaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "schemaBlockId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignPlaceholderTemplateDto",
        "fields": [
          {
            "name": "schemaBlockId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CampaignTemplateUsageDTO",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CloneSiteResultDto",
        "fields": [
          {
            "name": "formsCloned",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pagesCloned",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "targetSiteId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "targetSiteName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "templatesCloned",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateUserApiTokenResult",
        "fields": [
          {
            "name": "apiKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "expiresAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DashboardEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "panels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DashboardPanelConfig",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DashboardPanelConfig",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "x",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "y",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteUserApiTokenResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeviceScreenshotDto",
        "fields": [
          {
            "name": "desktop",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mobile",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tablet",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DisconnectUserGoogleAccountResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DisconnectUserMetaAccountResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DomainEntityDto",
        "fields": [
          {
            "name": "alias",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "domainName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "robots",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "siteDomains",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteDomainDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "sitemap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ssl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "EvaluatedFeatureFlagDto",
        "fields": [
          {
            "name": "isEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "options",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FIASESRecipient",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "to",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FIASendgridRecipient",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "to",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FeatureFlagConfigurationDto",
        "fields": [
          {
            "name": "context",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "enableTime",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "options",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FeatureFlagEntityDto",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "options",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ForceResyncGoogleAccountResult",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormEntityDto",
        "fields": [
          {
            "name": "botProtection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "botProtectionIntegration",
            "type": {
              "kind": "OBJECT",
              "name": "IntegrationDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "enableRecaptcha",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "fields",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormFieldEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "formIdentifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "integrations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormIntegrationEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "lastSubmission",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "recaptchaSiteToken",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "retentionPeriodDays",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "submitButtonLabel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "thankYouMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormFieldConfig",
        "fields": [
          {
            "name": "customCss",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "defaultValue",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "info",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "inputType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "options",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "KeyValue",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "presentation",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "validation",
            "type": {
              "kind": "OBJECT",
              "name": "FormFieldValidationConfig",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormFieldEntityDto",
        "fields": [
          {
            "name": "autocomplete",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "config",
            "type": {
              "kind": "OBJECT",
              "name": "FormFieldConfig",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "fieldIdentifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "helpText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isRequired",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "placeholder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormFieldValidationConfig",
        "fields": [
          {
            "name": "constraints",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormFieldValidationConstraint",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormFieldValidationConstraint",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "props",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormIntegrationActionEntityDto",
        "fields": [
          {
            "name": "disabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "disabledUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "formIntegration",
            "type": {
              "kind": "OBJECT",
              "name": "FormIntegrationEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "integration",
            "type": {
              "kind": "OBJECT",
              "name": "IntegrationDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "specification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormIntegrationActionLogEntity",
        "fields": [
          {
            "name": "formIntegrationAction",
            "type": {
              "kind": "OBJECT",
              "name": "FormIntegrationActionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isSuccess",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "requestData",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "response",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "submission",
            "type": {
              "kind": "OBJECT",
              "name": "FormSubmissionEntityDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormIntegrationEntityDto",
        "fields": [
          {
            "name": "actions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "FormIntegrationActionEntityDto",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionActionDto",
        "fields": [
          {
            "name": "hasActionLog",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pendingAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionEnqueueFlagOptionsDto",
        "fields": [
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "useNewLogic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionEntityDto",
        "fields": [
          {
            "name": "actionLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormSubmissionIntegrationActionLogEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "actions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormSubmissionActionDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "form",
            "type": {
              "kind": "OBJECT",
              "name": "FormEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recaptchaCheckStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "recaptchaScore",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "redirectURL",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionIntegrationActionEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "specification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionIntegrationActionLogEntityDto",
        "fields": [
          {
            "name": "action",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormSubmissionIntegrationActionEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "integration",
            "type": {
              "kind": "OBJECT",
              "name": "FormSubmissionIntegrationEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isSuccess",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "requestData",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "response",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FormSubmissionIntegrationEntityDto",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FranConnectSyncProcessResultDto",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GenerateSchemaBlockThumbnailResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GenerateSiteThumbnailResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GenerateTemplateThumbnailResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GeneratedAltText",
        "fields": [
          {
            "name": "results",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GeneratedAltTextItem",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GeneratedAltTextItem",
        "fields": [
          {
            "name": "altText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "imageUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GlofoxFormSubmission",
        "fields": [
          {
            "name": "agreementsStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "glofoxBranchId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "glofoxUserId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "OBJECT",
              "name": "GlofoxFormSubmissionPageDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "pageId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "step",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GlofoxFormSubmissionPageDto",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "urlPath",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GmbLocationEntityDto",
        "fields": [
          {
            "name": "addressLines",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "administrativeArea",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "gmbAccountName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "gmbName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "googleAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GmbLocationGoogleAccountDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "languageCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "locality",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "organisation",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "postalCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "regionCode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "sublocality",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GmbLocationGoogleAccountDto",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GmbLocationMappingEntityDto",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fieldName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "gmbLocation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GmbLocationEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "googleAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoogleAccountEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoogleAccountConnectionStatus",
        "fields": [
          {
            "name": "connected",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "error",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoogleAccountEntityDto",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "blocksMapped",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "connectionStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoogleAccountConnectionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "refreshTokenStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoogleAnalyticsAccountDto",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoogleAnalyticsPropertyDto",
        "fields": [
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "propertyId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ImpersonateResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ImportPagesFromJsonResult",
        "fields": [
          {
            "name": "errorMessage",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pagesCreated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ImportRedirectResolution",
        "fields": [
          {
            "name": "destination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "outcome",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pageUrlPath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "row",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "source",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "toUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ImportRedirectsPreview",
        "fields": [
          {
            "name": "invalidCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ImportRedirectResolution",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "urlCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "validCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ImportRedirectsResult",
        "fields": [
          {
            "name": "createdCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "rows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ImportRedirectResolution",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "skippedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InputValidationFlagOptionsDto",
        "fields": [
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "IntegrationConnectionStatus",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "IntegrationDto",
        "fields": [
          {
            "name": "connectionStatus",
            "type": {
              "kind": "OBJECT",
              "name": "IntegrationConnectionStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "organisationId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "specification",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "KeyValue",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LeadDataPoint",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MetaAccountConnectionStatus",
        "fields": [
          {
            "name": "connected",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "error",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MetaAccountEntityDto",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "connectionStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MetaAccountConnectionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "linkMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "fields": [
          {
            "name": "announceCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignAnnouncementResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "announceCampaignDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "bulkUpdateAltText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BulkUpdateAltTextResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "draftCustomFieldsId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "draftRevisionId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "items",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "pageId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "templateId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "cancelScheduledPublish",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "cancelScheduledTemplatePublish",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "clonePages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageCloneResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "clonePagesInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "cloneSite",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CloneSiteResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "cloneTTSchemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cloneTTSchemaWrapperInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "cloneTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cloneTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "copyFormIntegrationActionsToAnotherGroup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formIntegrationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "targetFormIntegrationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createBrand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "brand",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createCampaignDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createDashboard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DashboardEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "dashboard",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createDomain",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DomainEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "domain",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "form",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFormField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formField",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFormIntegration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formIntegration",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFormIntegrationAction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationActionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formIntegrationAction",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFormIntegrationActionLog",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationActionLogEntity",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formIntegrationActionLog",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createIntegration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntegrationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "integration",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createOrganisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "organisation",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createPageRevision",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createPageRevision",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createPageRevisionSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createPageRevisionSchema",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createPasswordReset",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResetPasswordResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createRedirect",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RedirectEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "redirect",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSchemaBlock",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchemaBlockEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createSite",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createSiteDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSubmission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormSubmissionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "submission",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createTTSchemaInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTTSchemaField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createTTSchemaFieldDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTTSchemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createTTSchemaWrapperInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "createTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createUserApiToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateUserApiTokenResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "expirySecs",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "deleteBrand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignDeleteResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteDomain",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DomainEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFormField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFormIntegration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFormIntegrationAction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationActionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteIntegration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntegrationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "deleteIntegration",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteOrganisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deletePage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteRedirect",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RedirectEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteSite",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaDeleteResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTTSchemaField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldDeleteResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTTSchemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperDeleteResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTemplateAndPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteUserApiToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteUserApiTokenResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteUserResource",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResourceEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "detachPagesAndDeleteTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "discardPageDraft",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "discardTemplateDraft",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "disconnectUserGoogleAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DisconnectUserGoogleAccountResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "disconnectUserMetaAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DisconnectUserMetaAccountResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "duplicateForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "duplicatePage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "exitImpersonate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ImpersonateResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "forceEndCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignForceEndResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "forceStartCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignForceStartResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "generateSchemaBlockThumbnail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateSchemaBlockThumbnailResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "blockId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "generateSiteThumbnail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateSiteThumbnailResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "generateTemplateThumbnail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateTemplateThumbnailResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "templateId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "grantUserResourceByEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResourceEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "userResource",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "impersonate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ImpersonateResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "importPagesFromJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ImportPagesFromJsonResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "importInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "importRedirects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ImportRedirectsResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "items",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "logout",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AuthResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "presignedUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AssetUploadResponseDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "asset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "previewImportRedirects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ImportRedirectsPreview",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "items",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "processFranConnectChanges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FranConnectSyncProcessResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "franConnectSyncDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "publishPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PublishPageResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "pageId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "removePageRevision",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "removePageRevisionSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "resetPassword",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResetPasswordResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "user",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "resetPasswordWithToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResetPasswordResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "user",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "restoreDeletedTTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "restoreDeletedTTSchemaField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "retriggerFormSubmissionActions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RetriggerFormSubmissionActionsResponseDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "revokeAllUserResourcesForOrganisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RevokeAllUserResourcesOnOrganisationResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "setBannerMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "message",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "syncAllGmbData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SyncResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "syncAllGoogleAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SyncAllGoogleAccountsResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "syncGmbAccountData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SyncResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "syncGmbLocationData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SyncResult",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "syncGoogleAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ForceResyncGoogleAccountResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "unpublishPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UnpublishPageResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "pageId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAllCampaignPagesOptInStatuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignPageOptInStatusUpdateResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignPagesOptInStatusAllUpdateDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateBrand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "brand",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateCampaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateCampaignDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateCampaignPageOptInStatuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignPageOptInStatusUpdateResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignPagesOptInStatusUpdateDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateDashboard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DashboardEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "dashboard",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFeatureFlag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FeatureFlagEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFeatureFlagConfiguration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FeatureFlagConfigurationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "form",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFormField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formField",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFormIntegrationAction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationActionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "action",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFormIntegrationPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormIntegrationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "formIntegrationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "pageIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "updateIntegration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntegrationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "integration",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateOrganisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "organisation",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePageSEOSettings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePreferredLocale",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "locale",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateRedirect",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RedirectEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "redirect",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSite",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateSiteDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSiteFormNotificationEmails",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteFormNotificationEmailDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormFieldEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "sortOrder",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateTTSchemaInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTTSchemaField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateTTSchemaFieldDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTTSchemaFieldOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldSortOrderUpdateResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateTTSchemaFieldSortOrderInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTTSchemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateTTSchemaWrapperInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "updateTemplateDto",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUserWithToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "user",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NumberOfLeads",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "percentChange",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrganisationEntityDto",
        "fields": [
          {
            "name": "brandsCount",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sites",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedSites",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageCloneResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageEntityDto",
        "fields": [
          {
            "name": "allowCrawling",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "brand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "brandId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "breadcrumbs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Breadcrumb",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "campaignId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "campaignParent",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "children",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "childrenCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customScriptBody",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customScriptHead",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "draftCustomFields",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "draftRevision",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "excludeFromSitemap",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lang",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metaDescription",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "metaTags",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "metaTitle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageType",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "parent",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "publishedCustomFields",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "publishedRevision",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sitePath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tags",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "template",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "urlPath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "urlSegment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageRevisionEntityDto",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "references",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resolvedReferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResolvedReferenceDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "schema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageRevisionSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "block",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "draftMode",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageRevisionSchemaEntityDto",
        "fields": [
          {
            "name": "anchorId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "campaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "hideBlockForCampaignPlaceholders",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inFooter",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "inHeader",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "properties",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PageRevisionSchemaProperties",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "schemaBlockId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "template",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ttschema",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaEntityDto",
              "ofType": null
            },
            "args": [
              {
                "name": "draftMode",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageRevisionSchemaProperties",
        "fields": [
          {
            "name": "dynamicReference",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fieldId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isDynamic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "valueReferences",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PageRevisionSchemaPropertyValueReference",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageRevisionSchemaPropertyValueReference",
        "fields": [
          {
            "name": "referenceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageTemplateUsageDTO",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedAuditLogs",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AuditLogEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedBrands",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "BrandEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedCampaignPages",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CampaignPageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedCampaigns",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CampaignEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedDashboards",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DashboardEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedDomains",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DomainEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedFormFields",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormFieldEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedFormIntegrations",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormIntegrationEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedFormSubmissions",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormSubmissionEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedForms",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FormEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGlofoxFormLeads",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GlofoxFormSubmission",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGmbLocationMappings",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GmbLocationMappingEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGmbLocations",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GmbLocationEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGoogleAccounts",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GoogleAccountEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGoogleAnalyticsAccounts",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GoogleAnalyticsAccountDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedGoogleAnalyticsProperties",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "GoogleAnalyticsPropertyDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedIntegration",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "IntegrationDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedMetaAccounts",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MetaAccountEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedOrganisations",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "OrganisationEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedPages",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedPendingImagesForAltTextGeneration",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PendingImageForAltTextGeneration",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedPublicPageDto",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PublicPageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedRedirects",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RedirectEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedRoles",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RoleEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedSites",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedTTSchemaFields",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaFieldEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedTTSchemaUsages",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaUsagesResult",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedTTSchemaWrappers",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaWrapperEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedTTSchemas",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedTemplates",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TemplateEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedUserResources",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserResourceEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedUsers",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginatedUsersWithRoles",
        "fields": [
          {
            "name": "items",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserWithRoles",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PendingImageForAltTextGeneration",
        "fields": [
          {
            "name": "assetId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "draftCustomFieldsId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "draftRevisionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "images",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AltTextPendingImage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "siteId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PrimaryDomainDto",
        "fields": [
          {
            "name": "alias",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "domainName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "robots",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "siteDomains",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteDomainDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "sitemap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ssl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PublicPageCampaignDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PublicPageEntityDto",
        "fields": [
          {
            "name": "allowCrawling",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "campaigns",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PublicPageCampaignDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customScriptBody",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customScriptHead",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "excludeFromSitemap",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "lang",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "metaDescription",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "metaTags",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "metaTitle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scheduledAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "sitePath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tags",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "urlPath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "urlSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PublishPageResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "fields": [
          {
            "name": "TTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "includedDeleted",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "adminSubmissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedFormSubmissions",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "actionStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "endDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "formId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "integrationTypes",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "organisationId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "recaptchaCheckStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "assetList",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssetEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "auditLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedAuditLogs",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "endDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "resourceId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "resourceType",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "userIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "bannerMessage",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "brand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "brands",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedBrands",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "campaign",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "campaignPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedCampaignPages",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "optedIn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "campaignPlaceholders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CampaignPlaceholderDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "pageIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "templateIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "campaigns",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedCampaigns",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "endsAfter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "endsBefore",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startsAfter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startsBefore",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "status",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "statuses",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "checkOverlappingCampaignPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CampaignPageUsageResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "pageId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "checkPageUsagesInCampaigns",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CampaignEntityDto",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "pageId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "checkTTSchemaUsages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedTTSchemaUsages",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "schemaId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "ttSchemaWrapperId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "dashboard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DashboardEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "dashboards",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedDashboards",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "domain",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DomainEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "domain",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "errorTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": [
              {
                "name": "domain",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "errorType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "path",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "evaluatedFeatureFlagsByNames",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "EvaluatedFeatureFlagDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "context",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "names",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "featureFlagConfiguration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FeatureFlagConfigurationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "featureFlagsByNames",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FeatureFlagEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "names",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "findAll",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedFormIntegrations",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "formId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "findAllOrganisationIntegrationTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": [
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "findOne",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "findPendingImagesForAltTextGeneration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedPendingImagesForAltTextGeneration",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "ttSchemaId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "form",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "forms",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedForms",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "generateAltText",
            "type": {
              "kind": "OBJECT",
              "name": "GeneratedAltText",
              "ofType": null
            },
            "args": [
              {
                "name": "imageUrls",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "generateSiteReport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReportResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "report",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getListOfUsagesForCampaignTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsagesOfCampaignTemplateDTO",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getListOfUsagesForForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsagesOfFormDTO",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getListOfUsagesForPageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsagesOfPageTemplateDTO",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getListOfUsagesForSWBTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsagesOfSWBDTO",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TemplateEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "pageIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "getPageTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "pageIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "gmbLocation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GmbLocationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "gmbName",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "id",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "gmbLocationMappings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGmbLocationMappings",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "gmbLocations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGmbLocations",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParam",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "googleAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoogleAccountEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "googleAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGoogleAccounts",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "googleAnalyticsAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoogleAnalyticsAccountDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "accountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "googleAccountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "googleAnalyticsAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGoogleAnalyticsAccounts",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "googleAccountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "googleAnalyticsProperties",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGoogleAnalyticsProperties",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "googleAccountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "googleAnalyticsAccountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "googleAnalyticsProperty",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoogleAnalyticsPropertyDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "googleAccountId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "propertyId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "integration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntegrationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "integrations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedIntegration",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "loggedInUser",
            "type": {
              "kind": "OBJECT",
              "name": "UserEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "login",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AuthResult",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "password",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "metaAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MetaAccountEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "metaAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedMetaAccounts",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "organisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "organisationBrands",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedBrands",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "organisationDomains",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedDomains",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "organisationUserResources",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedUserResources",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "organisationUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedUsers",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "organisations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedOrganisations",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "page",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "domain",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "id",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "slug",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "pageRevision",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "pageId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "pageRevisionFromPageData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "pageData",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "pageRevisionSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageRevisionSchemaEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedPages",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "exclude",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "excludeRecursive",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "order",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "orderDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pageId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pageIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "pageName",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "parentId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "requireAllowCrawling",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "requirePageTypeId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "schemaTypeId",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "templateId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "publicListPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedPublicPageDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "domain",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "fields",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "filters",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "latitude",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limitPageAncestorId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limitPageId",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limitPageParentId",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "longitude",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "orderBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pageType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "radius",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "redirects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedRedirects",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "search",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resolveReferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResolvedReferenceDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "pageId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "references",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "resourceUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedUsersWithRoles",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "email",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "resourceId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "resourceIdentifier",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedRoles",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "siteFormNotificationEmails",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteFormNotificationEmailDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sites",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedSites",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "brandId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "organisationId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "requireAnalyticsConfig",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "submission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormSubmissionEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "submissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedFormSubmissions",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "actionStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "endDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "formId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "recaptchaCheckStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "template",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TemplateEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "templates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedTemplates",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaign",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "campaignId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "order",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "orderDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "pageTypeId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "types",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "ttSchemaField",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaFieldEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "ttSchemaFields",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedTTSchemaFields",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "lifecycleStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "ttSchemaId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "ttSchemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "ttSchemaWrappers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedTTSchemaWrappers",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "ttSchemas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedTTSchemas",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "lifecycleStatus",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "siteId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "ttSchemaWrapperId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "visibilities",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "urlResolution",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UrlResolutionDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "domain",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "id",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "slug",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "UserEntityDto",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "userApiTokens",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserApiTokenDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "userByToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "userCanUpdateCampaignSomePageOptInStatuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SomeCampaignPagesUpdateableDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "campaignId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "userMetaAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserMetaAccountsDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userResource",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResourceEntityDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedUsers",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "conditions",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "count",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "name",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "role",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sortDirection",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "validateCampaignCreateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateCampaignUpdateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateCreatePageDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateCreateSiteDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateSiteName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteNameValidationDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "organisationId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "siteName",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaCreateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaFieldCreateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaFieldUpdateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaUpdateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaWrapperCloneDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaWrapperCreateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateTTSchemaWrapperUpdateDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateUpdatePageDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateUpdateSiteDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateUpdateTemplateInputDto",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ValidationResultDto",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "validationInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RedirectEntityDto",
        "fields": [
          {
            "name": "fromPath",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "redirectDomain",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "redirectHitCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToPageEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "toPage",
            "type": {
              "kind": "OBJECT",
              "name": "ToPageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "toType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "toUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportResultDto",
        "fields": [
          {
            "name": "stats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ReportStatDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportStatDto",
        "fields": [
          {
            "name": "data",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResetPasswordResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResolvedReferenceDto",
        "fields": [
          {
            "name": "dynamicReference",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RetriggerFormSubmissionActionsResponseDto",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RevokeAllUserResourcesOnOrganisationResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RoleEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "priority",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchemaBlockEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendgridEmailFrom",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteConfigDto",
        "fields": [
          {
            "name": "googleAnalytics",
            "type": {
              "kind": "OBJECT",
              "name": "SiteGoogleAnalyticsConfig",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "integrations",
            "type": {
              "kind": "OBJECT",
              "name": "SiteIntegrationConfigDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "version",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteDomainConfigDto",
        "fields": [
          {
            "name": "alias",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "domainName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ssl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteDomainDto",
        "fields": [
          {
            "name": "domainEntity",
            "type": {
              "kind": "OBJECT",
              "name": "DomainEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "siteEntity",
            "type": {
              "kind": "OBJECT",
              "name": "SiteEntityDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteEntityDto",
        "fields": [
          {
            "name": "brand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "config",
            "type": {
              "kind": "OBJECT",
              "name": "SiteConfigDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "customScriptBody",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customScriptHead",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "domains",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DomainEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "error404Template",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "error500Template",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "footerTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "glofoxFormSubmissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginatedGlofoxFormLeads",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "paginationParams",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "headerTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "TemplateEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "homepage",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "primaryDomain",
            "type": {
              "kind": "OBJECT",
              "name": "PrimaryDomainDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "siteDomainsWithPath",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SiteDomainConfigDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "templates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TemplateEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "thumbnailImageUrls",
            "type": {
              "kind": "OBJECT",
              "name": "DeviceScreenshotDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "timezone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ttSchemaWrapper",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaWrapperEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "webhooks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteFormNotificationEmailDto",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteGoogleAnalyticsConfig",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "googleAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "propertyId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteIntegrationConfigDto",
        "fields": [
          {
            "name": "glofox",
            "type": {
              "kind": "OBJECT",
              "name": "SiteIntegrationGlofoxConfigDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteIntegrationGlofixReportingConfigDto",
        "fields": [
          {
            "name": "apiUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "basicAuthToken",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteIntegrationGlofoxConfigDto",
        "fields": [
          {
            "name": "reporting",
            "type": {
              "kind": "OBJECT",
              "name": "SiteIntegrationGlofixReportingConfigDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SiteNameValidationDto",
        "fields": [
          {
            "name": "isValid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SomeCampaignPagesUpdateableDto",
        "fields": [
          {
            "name": "updateable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SyncAllGoogleAccountsResult",
        "fields": [
          {
            "name": "accountsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SyncResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaDeleteResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaEntityDto",
        "fields": [
          {
            "name": "deletedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "fields",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaFieldEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "subSchemas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "thumbnailImageUrls",
            "type": {
              "kind": "OBJECT",
              "name": "DeviceScreenshotDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "titlePlural",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "titleSingular",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ttschemaWrapper",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaWrapperEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "visibility",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaFieldDeleteResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaFieldEntityDto",
        "fields": [
          {
            "name": "TTSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TTSchemaEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "deletedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "hasMultipleValues",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "helpText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "readOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "required",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "typeDefinition",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "typeTTSchema",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "visibility",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaFieldSortOrderUpdateResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaUsagesResult",
        "fields": [
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "schemas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "templates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TemplateEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaWrapperDeleteResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TTSchemaWrapperEntityDto",
        "fields": [
          {
            "name": "deletable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "organisation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OrganisationEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "siteId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ttschemas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TTSchemaEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "query",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "type",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TemplateEntityDto",
        "fields": [
          {
            "name": "campaign",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deletedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "draftRevision",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageType",
            "type": {
              "kind": "OBJECT",
              "name": "TTSchemaEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "publishedRevision",
            "type": {
              "kind": "OBJECT",
              "name": "PageRevisionEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "site",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SiteEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "thumbnailImageUrls",
            "type": {
              "kind": "OBJECT",
              "name": "DeviceScreenshotDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ToPageEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metaDescription",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metaTitle",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "urlPath",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "urlSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TotalLeadsDataAverageDaily",
        "fields": [
          {
            "name": "average",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "percentChange",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TotalLeadsDataAveragePerPage",
        "fields": [
          {
            "name": "average",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "percentChange",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "URLRedirectEntityDto",
        "fields": [
          {
            "name": "target",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UnpublishPageResult",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UrlResolutionDto",
        "fields": [
          {
            "name": "page",
            "type": {
              "kind": "OBJECT",
              "name": "PageEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "redirect",
            "type": {
              "kind": "OBJECT",
              "name": "URLRedirectEntityDto",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsagesOfCampaignTemplateDTO",
        "fields": [
          {
            "name": "campaigns",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CampaignTemplateUsageDTO",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsagesOfFormDTO",
        "fields": [
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "templates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsagesOfPageTemplateDTO",
        "fields": [
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PageTemplateUsageDTO",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsagesOfSWBDTO",
        "fields": [
          {
            "name": "pages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "templates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserAccessDto",
        "fields": [
          {
            "name": "rules",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserApiTokenDto",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "expiresAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastAccessAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserEntityDto",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserAccessDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "featureFlags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserFeatureFlagsDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "impersonatingUser",
            "type": {
              "kind": "OBJECT",
              "name": "UserEntityDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "preferredLocale",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "verified",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserFeatureFlagsDto",
        "fields": [
          {
            "name": "formSubmissionEnqueue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FormSubmissionEnqueueFlagOptionsDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "inputValidation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InputValidationFlagOptionsDto",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserMetaAccountsDto",
        "fields": [
          {
            "name": "metaAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MetaAccountEntityDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserResourceEntityDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceIdentifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RoleEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserEntityDto",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserResourcePermissionsDto",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resourceIdentifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "roleId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserRoleDto",
        "fields": [
          {
            "name": "explicit",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "from",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResourceEntityDto",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserWithRoles",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "explicitRole",
            "type": {
              "kind": "OBJECT",
              "name": "UserRoleDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "primaryRole",
            "type": {
              "kind": "OBJECT",
              "name": "UserRoleDto",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserRoleDto",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ValidationResultDto",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrappedValidationError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "hasErrors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "WrappedValidationError",
        "fields": [
          {
            "name": "children",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrappedValidationError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "constraints",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "property",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Any"
      }
    ],
    "directives": []
  }
} as unknown as IntrospectionQuery;
